import { C as e, S as t, d as n, f as r, g as i, h as a, i as o, m as s, p as c, v as l, w as u, y as d } from "./nodeToBlock-e66ZlC--.js";
import { n as f, t as p } from "./BlockNoteExtension-BBlRdZNO.js";
import { DOMParser as m, Fragment as h, Slice as g } from "prosemirror-model";
import { ReplaceStep as _ } from "prosemirror-transform";
import { Extension as v, InputRule as ee, Mark as te, Node as y, callOrReturn as ne, findParentNode as re, getExtensionField as ie, markInputRule as ae, mergeAttributes as oe } from "@tiptap/core";
import { Plugin as se, PluginKey as ce, TextSelection as b } from "prosemirror-state";
import { DOMParser as le, DOMSerializer as ue, Fragment as de } from "@tiptap/pm/model";
import { CellSelection as fe, TableMap as pe, TableView as me, columnResizing as he, goToNextCell as ge, isInTable as _e, moveCellForward as ve, nextCell as ye, selectionCell as be, tableEditing as xe } from "prosemirror-tables";
import { createHighlightPlugin as Se } from "prosemirror-highlight";
import { createParser as Ce } from "prosemirror-highlight/shiki";
import { Plugin as we, PluginKey as Te } from "@tiptap/pm/state";
import { Decoration as Ee, DecorationSet as De } from "@tiptap/pm/view";
import { Decoration as Oe, DecorationSet as ke } from "prosemirror-view";
import Ae from "@tiptap/extension-bold";
import je from "@tiptap/extension-code";
import Me from "@tiptap/extension-italic";
import Ne from "@tiptap/extension-strike";
import Pe from "@tiptap/extension-underline";
//#region src/util/table.ts
function x(e) {
	return C(e) ? { ...e } : S(e) ? {
		type: "tableCell",
		content: [].concat(e.content),
		props: {
			backgroundColor: e.props?.backgroundColor ?? "default",
			textColor: e.props?.textColor ?? "default",
			textAlignment: e.props?.textAlignment ?? "left",
			colspan: e.props?.colspan ?? 1,
			rowspan: e.props?.rowspan ?? 1
		}
	} : {
		type: "tableCell",
		content: [].concat(e),
		props: {
			backgroundColor: "default",
			textColor: "default",
			textAlignment: "left",
			colspan: 1,
			rowspan: 1
		}
	};
}
function S(e) {
	return e != null && typeof e != "string" && !Array.isArray(e) && e.type === "tableCell";
}
function C(e) {
	return S(e) && e.props !== void 0 && e.content !== void 0;
}
function w(e) {
	return C(e) ? e.props.colspan ?? 1 : 1;
}
function T(e) {
	return C(e) ? e.props.rowspan ?? 1 : 1;
}
//#endregion
//#region src/util/browser.ts
var Fe = () => typeof navigator < "u" && (/Mac/.test(navigator.platform) || /AppleWebKit/.test(navigator.userAgent) && /Mobile\/\w+/.test(navigator.userAgent));
function E(e, t = "Ctrl") {
	return Fe() ? e.replace("Mod", "⌘") : e.replace("Mod", t);
}
function D(...e) {
	return [...new Set(e.filter((e) => e).join(" ").split(" "))].join(" ");
}
var Ie = () => /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
//#endregion
//#region src/blocks/defaultBlockHelpers.ts
function Le(e, t, n, r) {
	let i = document.createElement("div");
	i.className = D("bn-block-content", n.class), i.setAttribute("data-content-type", e);
	for (let [e, t] of Object.entries(n)) e !== "class" && i.setAttribute(e, t);
	let a = document.createElement(t);
	a.className = D("bn-inline-content", r.class);
	for (let [e, t] of Object.entries(r)) e !== "class" && a.setAttribute(e, t);
	return i.appendChild(a), {
		dom: i,
		contentDOM: a
	};
}
var Re = (e, t) => {
	let n = z(e, t.pmSchema);
	n.type.name === "blockContainer" && (n = n.firstChild);
	let r = t.pmSchema.nodes[n.type.name].spec.toDOM;
	if (r === void 0) throw Error("This block has no default HTML serialization as its corresponding TipTap node doesn't implement `renderHTML`.");
	let i = r(n);
	if (typeof i != "object" || !("dom" in i)) throw Error("Cannot use this block's default HTML serialization as its corresponding TipTap node's `renderHTML` function does not return an object with the `dom` property.");
	return i;
};
function ze(e, t = "<br>") {
	let n = e.querySelectorAll("p");
	if (n.length > 1) {
		let e = n[0];
		for (let r = 1; r < n.length; r++) {
			let i = n[r];
			e.innerHTML += t + i.innerHTML, i.remove();
		}
	}
}
//#endregion
//#region src/api/nodeUtil.ts
function O(e, t) {
	let n, r;
	if (t.firstChild.descendants((t, i) => n ? !1 : !Be(t) || t.attrs.id !== e ? !0 : (n = t, r = i + 1, !1)), !(n === void 0 || r === void 0)) return {
		node: n,
		posBeforeNode: r
	};
}
function Be(e) {
	return e.type.isInGroup("bnBlock");
}
//#endregion
//#region src/api/blockManipulation/getBlock/getBlock.ts
function Ve(e, t) {
	let r = typeof t == "string" ? t : t.id, i = n(e), a = O(r, e);
	if (a) return o(a.node, i);
}
function He(e, t) {
	let r = O(typeof t == "string" ? t : t.id, e), i = n(e);
	if (!r) return;
	let a = e.resolve(r.posBeforeNode).nodeBefore;
	if (a) return o(a, i);
}
function Ue(e, t) {
	let r = O(typeof t == "string" ? t : t.id, e), i = n(e);
	if (!r) return;
	let a = e.resolve(r.posBeforeNode + r.node.nodeSize).nodeAfter;
	if (a) return o(a, i);
}
function We(e, t) {
	let r = typeof t == "string" ? t : t.id, i = n(e), a = O(r, e);
	if (!a) return;
	let s = e.resolve(a.posBeforeNode), c = s.node(), l = s.node(-1), u = l.type.name === "doc" ? void 0 : c.type.name === "blockGroup" ? l : c;
	if (u) return o(u, i);
}
//#endregion
//#region src/util/string.ts
function k(e) {
	return "data-" + e.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase();
}
function Ge(e) {
	let t = e.split("/");
	return !t.length || t[t.length - 1] === "" ? e : t[t.length - 1];
}
function Ke(e) {
	let t = [
		"mp4",
		"webm",
		"ogg",
		"mov",
		"mkv",
		"flv",
		"avi",
		"wmv",
		"m4v"
	];
	try {
		let n = new URL(e).pathname.split(".").pop()?.toLowerCase() || "";
		return t.includes(n);
	} catch {
		return !1;
	}
}
//#endregion
//#region src/schema/blocks/internal.ts
function qe(e) {
	let t = {};
	return Object.entries(e).forEach(([e, n]) => {
		t[e] = {
			default: n.default,
			keepOnSplit: !0,
			parseHTML: (t) => {
				let r = t.getAttribute(k(e));
				if (r === null) return null;
				if (n.default === void 0 && n.type === "boolean" || n.default !== void 0 && typeof n.default == "boolean") return r === "true" ? !0 : r === "false" ? !1 : null;
				if (n.default === void 0 && n.type === "number" || n.default !== void 0 && typeof n.default == "number") {
					let e = parseFloat(r);
					return !Number.isNaN(e) && Number.isFinite(e) ? e : null;
				}
				return r;
			},
			renderHTML: (t) => t[e] === n.default ? {} : { [k(e)]: t[e] }
		};
	}), t;
}
function Je(e, t, n) {
	let r = e();
	if (r === void 0) throw Error("Cannot find node position");
	let i = t.resolve(r).node().attrs.id;
	if (!i) throw Error("Block doesn't have id");
	let a = Ve(t, i);
	if (a.type !== n) throw Error("Block type does not match");
	return a;
}
function A(e, t, n, r, i = !1, a) {
	let o = document.createElement("div");
	if (a !== void 0) for (let [e, t] of Object.entries(a)) e !== "class" && o.setAttribute(e, t);
	o.className = D("bn-block-content", a?.class || ""), o.setAttribute("data-content-type", t);
	for (let [e, t] of Object.entries(n)) t !== r[e].default && o.setAttribute(k(e), t);
	return i && o.setAttribute("data-file-block", ""), o.appendChild(e.dom), e.contentDOM && (e.contentDOM.className = D("bn-inline-content", e.contentDOM.className)), {
		...e,
		dom: o
	};
}
function Ye(e, t, n) {
	return {
		config: {
			type: e.type,
			content: e.content,
			propSchema: t
		},
		implementation: {
			node: e.node,
			render: Re,
			toExternalHTML: Re
		},
		extensions: n
	};
}
//#endregion
//#region src/schema/blocks/createSpec.ts
function Xe(e, t) {
	e.stopEvent = (e) => (e.type === "mousedown" && setTimeout(() => {
		t.view.dom.blur();
	}, 10), !0);
}
function Ze(e, t) {
	let n = [{
		tag: "[data-content-type=" + e.type + "]",
		contentElement: ".bn-inline-content"
	}];
	return t.parse && n.push({
		tag: "*",
		getAttrs(e) {
			if (typeof e == "string") return !1;
			let n = t.parse?.(e);
			return n === void 0 ? !1 : n;
		},
		preserveWhitespace: !0,
		getContent: e.content === "inline" || e.content === "none" ? (n, r) => {
			if (t.parseContent) {
				let e = t.parseContent({
					el: n,
					schema: r
				});
				if (e !== void 0) return e;
			}
			if (e.content === "inline") {
				let e = n.cloneNode(!0);
				return ze(e, t.meta?.code ? "\n" : "<br>"), le.fromSchema(r).parse(e, {
					topNode: r.nodes.paragraph.create(),
					preserveWhitespace: !0
				}).content;
			}
			return de.empty;
		} : void 0
	}), n;
}
function Qe(e, t, n, r) {
	let i = t.node || y.create({
		name: e.type,
		content: e.content === "inline" ? "inline*" : e.content === "none" ? "" : e.content,
		group: "blockContent",
		selectable: t.meta?.selectable ?? !0,
		isolating: t.meta?.isolating ?? !0,
		code: t.meta?.code ?? !1,
		defining: t.meta?.defining ?? !0,
		priority: r,
		addAttributes() {
			return qe(e.propSchema);
		},
		parseHTML() {
			return Ze(e, t);
		},
		renderHTML({ HTMLAttributes: n }) {
			let r = document.createElement("div");
			return A({
				dom: r,
				contentDOM: e.content === "inline" ? r : void 0
			}, e.type, {}, e.propSchema, t.meta?.fileBlockAccept !== void 0, n);
		},
		addNodeView() {
			return (n) => {
				let r = this.options.editor, i = Je(n.getPos, n.view.state.doc, e.type), a = this.options.domAttributes?.blockContent || {}, o = t.render.call({
					blockContentDOMAttributes: a,
					props: n,
					renderType: "nodeView"
				}, i, r);
				return t.meta?.selectable === !1 && Xe(o, this.editor), o;
			};
		}
	});
	if (i.name !== e.type) throw Error("Node name does not match block type. This is a bug in BlockNote.");
	return {
		config: e,
		implementation: {
			...t,
			node: i,
			render(e, n) {
				let r = i.options.domAttributes?.blockContent || {};
				return t.render.call({
					blockContentDOMAttributes: r,
					props: void 0,
					renderType: "dom"
				}, e, n);
			},
			toExternalHTML: (e, n, r) => {
				let a = i.options.domAttributes?.blockContent || {};
				return t.toExternalHTML?.call({ blockContentDOMAttributes: a }, e, n, r) ?? t.render.call({
					blockContentDOMAttributes: a,
					renderType: "dom",
					props: void 0
				}, e, n);
			}
		},
		extensions: n
	};
}
function j(e) {
	return e;
}
function M(e, t, n) {
	return (r = {}) => {
		let i = typeof e == "function" ? e(r) : e, a = typeof t == "function" ? t(r) : t, o = n ? typeof n == "function" ? n(r) : n : void 0;
		return {
			config: i,
			implementation: {
				...a,
				toExternalHTML(e, t, n) {
					let r = a.toExternalHTML?.call({ blockContentDOMAttributes: this.blockContentDOMAttributes }, e, t, n);
					if (r !== void 0) return A(r, e.type, e.props, i.propSchema, a.meta?.fileBlockAccept !== void 0);
				},
				render(e, t) {
					return A(a.render.call({
						blockContentDOMAttributes: this.blockContentDOMAttributes,
						renderType: this.renderType,
						props: this.props
					}, e, t), e.type, e.props, i.propSchema, a.meta?.fileBlockAccept !== void 0, this.blockContentDOMAttributes);
				}
			},
			extensions: o
		};
	};
}
//#endregion
//#region src/schema/inlineContent/internal.ts
function $e(e, t, n, r) {
	return e.dom.setAttribute("data-inline-content-type", t), Object.entries(n).filter(([e, t]) => t !== r[e].default).map(([e, t]) => [k(e), t]).forEach(([t, n]) => e.dom.setAttribute(t, n)), e.contentDOM && e.contentDOM.setAttribute("data-editable", ""), e;
}
function et(e) {
	return { Backspace: ({ editor: t }) => {
		let n = t.state.selection.$from;
		return t.state.selection.empty && n.node().type.name === e.type && n.parentOffset === 0;
	} };
}
function tt(e, t) {
	return {
		config: e,
		implementation: t
	};
}
function nt(e, t, n) {
	return tt({
		type: e.name,
		propSchema: t,
		content: e.config.content === "inline*" ? "styled" : "none"
	}, {
		...n,
		node: e
	});
}
function rt(e) {
	return Object.fromEntries(Object.entries(e).map(([e, t]) => [e, t.config]));
}
//#endregion
//#region src/schema/styles/internal.ts
function it(e) {
	return e === "boolean" ? {} : { stringValue: {
		default: void 0,
		keepOnSplit: !0,
		parseHTML: (e) => e.getAttribute("data-value"),
		renderHTML: (e) => e.stringValue === void 0 ? {} : { "data-value": e.stringValue }
	} };
}
function N(e, t, n, r) {
	return e.dom.setAttribute("data-style-type", t), r === "string" && e.dom.setAttribute("data-value", n), e.contentDOM && e.contentDOM.setAttribute("data-editable", ""), e;
}
function at(e, t) {
	return {
		config: e,
		implementation: t
	};
}
function P(e, t) {
	return at({
		type: e.name,
		propSchema: t
	}, {
		mark: e,
		render(t, n) {
			let r = n.pmSchema.marks[e.name].spec.toDOM;
			if (r === void 0) throw Error("This block has no default HTML serialization as its corresponding TipTap node doesn't implement `renderHTML`.");
			let i = n.pmSchema.mark(e.name, { stringValue: t }), a = ue.renderSpec(document, r(i, !0));
			if (typeof a != "object" || !("dom" in a)) throw Error("Cannot use this block's default HTML serialization as its corresponding TipTap mark's `renderHTML` function does not return an object with the `dom` property.");
			return a;
		},
		toExternalHTML(t, n) {
			let r = n.pmSchema.marks[e.name].spec.toDOM;
			if (r === void 0) throw Error("This block has no default HTML serialization as its corresponding TipTap node doesn't implement `renderHTML`.");
			let i = n.pmSchema.mark(e.name, { stringValue: t }), a = ue.renderSpec(document, r(i, !0));
			if (typeof a != "object" || !("dom" in a)) throw Error("Cannot use this block's default HTML serialization as its corresponding TipTap mark's `renderHTML` function does not return an object with the `dom` property.");
			return a;
		}
	});
}
function ot(e) {
	return Object.fromEntries(Object.entries(e).map(([e, t]) => [e, t.config]));
}
//#endregion
//#region src/schema/styles/createSpec.ts
function st(e, t) {
	let n = [{
		tag: `[data-style-type="${e.type}"]`,
		contentElement: (e) => {
			let t = e;
			return t.matches("[data-editable]") ? t : t.querySelector("[data-editable]") || t;
		}
	}];
	return t && n.push({
		tag: "*",
		consuming: !1,
		getAttrs(e) {
			if (typeof e == "string") return !1;
			let n = t?.(e);
			return n === void 0 ? !1 : { stringValue: n };
		}
	}), n;
}
function ct(e, t) {
	let n = te.create({
		name: e.type,
		addAttributes() {
			return it(e.propSchema);
		},
		parseHTML() {
			return st(e, t.parse);
		},
		renderHTML({ mark: n }) {
			return N((t.toExternalHTML || t.render)(n.attrs.stringValue), e.type, n.attrs.stringValue, e.propSchema);
		},
		addMarkView() {
			return ({ mark: n }) => N(t.render(n.attrs.stringValue), e.type, n.attrs.stringValue, e.propSchema);
		}
	});
	return at(e, {
		...t,
		mark: n,
		render: (n) => N(t.render(n), e.type, n, e.propSchema),
		toExternalHTML: (n) => N((t.toExternalHTML || t.render)(n), e.type, n, e.propSchema)
	});
}
//#endregion
//#region src/util/topo-sort.ts
function lt(e) {
	let t = dt(e), { roots: n, nonRoots: r } = ft(t), i = [];
	for (; n.size;) {
		i.push(n);
		let r = /* @__PURE__ */ new Set();
		for (let i of n) {
			let n = e.get(i);
			if (n) for (let e of n) {
				let n = t.get(e);
				if (n === void 0) continue;
				let i = n - 1;
				t.set(e, i), i === 0 && r.add(e);
			}
		}
		n = r;
	}
	if (r = ft(t).nonRoots, r.size) throw Error(`Cycle(s) detected; toposort only works on acyclic graphs. Cyclic nodes: ${Array.from(r).join(", ")}`);
	return i;
}
function ut(e) {
	return lt(pt(e));
}
function dt(e) {
	let t = /* @__PURE__ */ new Map();
	for (let [n, r] of e.entries()) {
		t.has(n) || t.set(n, 0);
		for (let e of r) {
			let n = t.get(e) ?? 0;
			t.set(e, n + 1);
		}
	}
	return t;
}
function ft(e) {
	let t = /* @__PURE__ */ new Set(), n = /* @__PURE__ */ new Set();
	for (let [r, i] of e.entries()) i === 0 ? t.add(r) : n.add(r);
	return {
		roots: t,
		nonRoots: n
	};
}
function pt(e) {
	let t = /* @__PURE__ */ new Map();
	for (let [n, r] of e.entries()) {
		t.has(n) || t.set(n, /* @__PURE__ */ new Set());
		for (let e of r) t.has(e) || t.set(e, /* @__PURE__ */ new Set()), t.get(e).add(n);
	}
	return t;
}
function mt() {
	return /* @__PURE__ */ new Map();
}
function ht(e, t, n) {
	return e.has(t) || e.set(t, /* @__PURE__ */ new Set()), e.get(t).add(n), e;
}
function gt(e) {
	let t = mt();
	for (let n of e) Array.isArray(n.runsBefore) && n.runsBefore.length > 0 ? n.runsBefore.forEach((e) => {
		ht(t, n.key, e);
	}) : ht(t, "default", n.key);
	let n = ut(t), r = n.findIndex((e) => e.has("default"));
	return (e) => 91 + (n.findIndex((t) => t.has(e)) + r) * 10;
}
//#endregion
//#region src/schema/schema.ts
function _t(e) {
	return e && Object.fromEntries(Object.entries(e).filter(([, e]) => e !== void 0));
}
var vt = class {
	BlockNoteEditor = "only for types";
	Block = "only for types";
	PartialBlock = "only for types";
	inlineContentSpecs;
	styleSpecs;
	blockSpecs;
	blockSchema;
	inlineContentSchema;
	styleSchema;
	constructor(e) {
		this.opts = e;
		let { blockSpecs: t, inlineContentSpecs: n, styleSpecs: r, blockSchema: i, inlineContentSchema: a, styleSchema: o } = this.init();
		this.blockSpecs = t, this.styleSpecs = r, this.styleSchema = o, this.inlineContentSpecs = n, this.blockSchema = i, this.inlineContentSchema = a;
	}
	init() {
		let e = gt(Object.entries({
			...this.opts.blockSpecs,
			...this.opts.inlineContentSpecs,
			...this.opts.styleSpecs
		}).map(([e, t]) => ({
			key: e,
			runsBefore: t.implementation?.runsBefore ?? []
		}))), t = Object.fromEntries(Object.entries(this.opts.blockSpecs).map(([t, n]) => [t, Qe(n.config, n.implementation, n.extensions, e(t))])), n = Object.fromEntries(Object.entries(this.opts.inlineContentSpecs).map(([t, n]) => typeof n.config == "object" ? [t, {
			...n,
			implementation: {
				...n.implementation,
				node: n.implementation?.node.extend({ priority: e(t) })
			}
		}] : [t, n])), r = Object.fromEntries(Object.entries(this.opts.styleSpecs).map(([t, n]) => [t, {
			...n,
			implementation: {
				...n.implementation,
				mark: n.implementation?.mark.extend({ priority: e(t) })
			}
		}]));
		return {
			blockSpecs: t,
			blockSchema: Object.fromEntries(Object.entries(t).map(([e, t]) => [e, t.config])),
			inlineContentSpecs: _t(n),
			styleSpecs: _t(r),
			inlineContentSchema: rt(n),
			styleSchema: ot(r)
		};
	}
	extend(e) {
		Object.assign(this.opts.blockSpecs, e.blockSpecs), Object.assign(this.opts.inlineContentSpecs, e.inlineContentSpecs), Object.assign(this.opts.styleSpecs, e.styleSpecs);
		let { blockSpecs: t, inlineContentSpecs: n, styleSpecs: r, blockSchema: i, inlineContentSchema: a, styleSchema: o } = this.init();
		return this.blockSpecs = t, this.styleSpecs = r, this.styleSchema = o, this.inlineContentSpecs = n, this.blockSchema = i, this.inlineContentSchema = a, this;
	}
};
//#endregion
//#region src/api/blockManipulation/tables/tables.ts
function F(e) {
	let { height: t, width: n } = yt(e), r = Array(t).fill(!1).map(() => Array(n).fill(null)), i = (e, i) => {
		for (let a = e; a < t; a++) for (let e = i; e < n; e++) if (!r[a][e]) return {
			row: a,
			col: e
		};
		throw Error("Unable to create occupancy grid for table, no more available cells");
	};
	for (let t = 0; t < e.content.rows.length; t++) for (let n = 0; n < e.content.rows[t].cells.length; n++) {
		let a = x(e.content.rows[t].cells[n]), o = T(a), s = w(a), { row: c, col: l } = i(t, n);
		for (let e = c; e < c + o; e++) for (let i = l; i < l + s; i++) {
			if (r[e][i]) throw Error(`Unable to create occupancy grid for table, cell at ${e},${i} is already occupied`);
			r[e][i] = {
				row: t,
				col: n,
				rowspan: o,
				colspan: s,
				cell: a
			};
		}
	}
	return r;
}
function I(e) {
	let t = /* @__PURE__ */ new Set();
	return e.map((e) => ({ cells: e.map((e) => t.has(e.row + ":" + e.col) ? !1 : (t.add(e.row + ":" + e.col), e.cell)).filter((e) => e !== !1) }));
}
function L(e, t, n = F(t)) {
	for (let t = 0; t < n.length; t++) for (let r = 0; r < n[t].length; r++) {
		let i = n[t][r];
		if (i && i.row === e.row && i.col === e.col) return {
			row: t,
			col: r,
			cell: i.cell
		};
	}
	throw Error(`Unable to resolve relative table cell indices for table, cell at ${e.row},${e.col} is not occupied`);
}
function yt(e) {
	let t = e.content.rows.length, n = 0;
	return e.content.rows.forEach((e) => {
		let t = 0;
		e.cells.forEach((e) => {
			t += w(e);
		}), n = Math.max(n, t);
	}), {
		height: t,
		width: n
	};
}
function bt(e, t, n = F(t)) {
	let r = n[e.row]?.[e.col];
	if (r) return {
		row: r.row,
		col: r.col,
		cell: r.cell
	};
}
function xt(e, t) {
	let n = F(e);
	if (t < 0 || t >= n.length) return [];
	let r = 0;
	for (let e = 0; e < t; e++) {
		let e = n[r]?.[0];
		if (!e) return [];
		r += e.rowspan;
	}
	let i = Array(n[0].length).fill(!1).map((t, i) => bt({
		row: r,
		col: i
	}, e, n)).filter((e) => e !== void 0);
	return i.filter((e, t) => i.findIndex((t) => t.row === e.row && t.col === e.col) === t);
}
function St(e, t) {
	let n = F(e);
	if (t < 0 || t >= n[0].length) return [];
	let r = 0;
	for (let e = 0; e < t; e++) {
		let e = n[0]?.[r];
		if (!e) return [];
		r += e.colspan;
	}
	let i = Array(n.length).fill(!1).map((t, i) => bt({
		row: i,
		col: r
	}, e, n)).filter((e) => e !== void 0);
	return i.filter((e, t) => i.findIndex((t) => t.row === e.row && t.col === e.col) === t);
}
function Ct(e, t, n, r = F(e)) {
	let { col: i } = L({
		row: 0,
		col: t
	}, e, r), { col: a } = L({
		row: 0,
		col: n
	}, e, r);
	return r.forEach((e) => {
		let [t] = e.splice(i, 1);
		e.splice(a, 0, t);
	}), I(r);
}
function wt(e, t, n, r = F(e)) {
	let { row: i } = L({
		row: t,
		col: 0
	}, e, r), { row: a } = L({
		row: n,
		col: 0
	}, e, r), [o] = r.splice(i, 1);
	return r.splice(a, 0, o), I(r);
}
function Tt(n) {
	return n ? S(n) ? Tt(n.content) : typeof n == "string" ? n.length === 0 : Array.isArray(n) ? n.every((n) => typeof n == "string" ? n.length === 0 : e(n) ? n.text.length === 0 : t(n) ? typeof n.content == "string" ? n.content.length === 0 : n.content.every((e) => e.text.length === 0) : !1) : !1 : !0;
}
function Et(e, t, n = F(e)) {
	if (t === "columns") {
		let e = 0;
		for (let t = n[0].length - 1; t >= 0 && n.every((e) => Tt(e[t].cell) && e[t].colspan === 1); t--) e++;
		for (let t = n.length - 1; t >= 0; t--) {
			let r = Math.max(n[t].length - e, 1);
			n[t] = n[t].slice(0, r);
		}
		return I(n);
	}
	let r = 0;
	for (let e = n.length - 1; e >= 0 && n[e].every((e) => Tt(e.cell) && e.rowspan === 1); e--) r++;
	let i = Math.min(r, n.length - 1);
	return n.splice(n.length - i, i), I(n);
}
function Dt(e, t, n, r = F(e)) {
	let { width: i, height: a } = yt(e);
	if (t === "columns") r.forEach((e, t) => {
		if (n >= 0) for (let r = 0; r < n; r++) e.push({
			row: t,
			col: Math.max(...e.map((e) => e.col)) + 1,
			rowspan: 1,
			colspan: 1,
			cell: x("")
		});
		else e.splice(i + n, -1 * n);
	});
	else if (n > 0) for (let e = 0; e < n; e++) {
		let t = Array(i).fill(null).map((t, n) => ({
			row: a + e,
			col: n,
			rowspan: 1,
			colspan: 1,
			cell: x("")
		}));
		r.push(t);
	}
	else n < 0 && r.splice(a + n, -1 * n);
	return I(r);
}
function Ot(e, t, n) {
	let r = xt(e, n);
	if (!r.some((e) => T(e.cell) > 1)) return !0;
	let i = n, a = n;
	return r.forEach((e) => {
		let t = T(e.cell);
		i = Math.max(i, e.row + t - 1), a = Math.min(a, e.row);
	}), t < n ? n === i : n === a;
}
function kt(e, t, n) {
	let r = St(e, n);
	if (!r.some((e) => w(e.cell) > 1)) return !0;
	let i = n, a = n;
	return r.forEach((e) => {
		let t = w(e.cell);
		i = Math.max(i, e.col + t - 1), a = Math.min(a, e.col);
	}), t < n ? n === i : n === a;
}
function At(e, t, n) {
	let r = L(e, n), i = L(t, n);
	return r.col === i.col;
}
//#endregion
//#region src/api/nodeConversions/blockToNode.ts
function jt(e, t, n, r) {
	let i = [];
	for (let [r, a] of Object.entries(e.styles || {})) {
		let e = n[r];
		if (!e) throw Error(`style ${r} not found in styleSchema`);
		if (e.propSchema === "boolean") a && i.push(t.mark(r));
		else if (e.propSchema === "string") a && i.push(t.mark(r, { stringValue: a }));
		else throw new d(e.propSchema);
	}
	return !r || !t.nodes[r].spec.code ? e.text.split(/(\n)/g).filter((e) => e.length > 0).map((e) => e === "\n" ? t.nodes.hardBreak.createChecked() : t.text(e, i)) : e.text.length > 0 ? [t.text(e.text, i)] : [];
}
function Mt(e, t, n) {
	let r = t.marks.link.create({ href: e.href });
	return Nt(e.content, t, n).map((e) => {
		if (e.type.name === "text") return e.mark([...e.marks, r]);
		if (e.type.name === "hardBreak") return e;
		throw Error("unexpected node type");
	});
}
function Nt(e, t, n, r) {
	let i = [];
	if (typeof e == "string") return i.push(...jt({
		type: "text",
		text: e,
		styles: {}
	}, t, n, r)), i;
	for (let a of e) i.push(...jt(a, t, n, r));
	return i;
}
function R(n, i, a, o = r(i)) {
	let s = [];
	for (let r of n) typeof r == "string" ? s.push(...Nt(r, i, o, a)) : t(r) ? s.push(...Mt(r, i, o)) : e(r) ? s.push(...Nt([r], i, o, a)) : s.push(Ft(r, i, o));
	return s;
}
function Pt(e, t, n = r(t)) {
	let i = [], a = Array(e.headerRows ?? 0).fill(!0), o = Array(e.headerCols ?? 0).fill(!0), s = e.columnWidths ?? [];
	for (let r = 0; r < e.rows.length; r++) {
		let c = e.rows[r], l = [], u = a[r];
		for (let i = 0; i < c.cells.length; i++) {
			let a = c.cells[i], d = o[i], f = null, p = L({
				row: r,
				col: i
			}, {
				type: "table",
				content: e
			}), m = s[p.col] ? [s[p.col]] : null;
			if (a) if (typeof a == "string") f = t.text(a);
			else if (S(a)) {
				a.content && (f = R(a.content, t, "tableParagraph", n));
				let e = w(a);
				e > 1 && (m = Array(e).fill(!1).map((e, t) => s[p.col + t] ?? void 0));
			} else f = R(a, t, "tableParagraph", n);
			let h = t.nodes[d || u ? "tableHeader" : "tableCell"].createChecked({
				...S(a) ? a.props : {},
				colwidth: m
			}, t.nodes.tableParagraph.createChecked(void 0, f));
			l.push(h);
		}
		let d = t.nodes.tableRow.createChecked({}, l);
		i.push(d);
	}
	return i;
}
function Ft(e, t, n) {
	let r, i = e.type;
	if (i === void 0 && (i = "paragraph"), !t.nodes[i]) throw Error(`node type ${i} not found in schema`);
	if (!e.content) r = t.nodes[i].createChecked(e.props);
	else if (typeof e.content == "string") {
		let a = R([e.content], t, i, n);
		r = t.nodes[i].createChecked(e.props, a);
	} else if (Array.isArray(e.content)) {
		let a = R(e.content, t, i, n);
		r = t.nodes[i].createChecked(e.props, a);
	} else if (e.content.type === "tableContent") {
		let a = Pt(e.content, t, n);
		r = t.nodes[i].createChecked(e.props, a);
	} else throw new d(e.content.type);
	return r;
}
function z(e, t, n = r(t)) {
	let i = e.id;
	i === void 0 && (i = u.options.generateID());
	let a = [];
	if (e.children) for (let r of e.children) a.push(z(r, t, n));
	if (!e.type || t.nodes[e.type].isInGroup("blockContent")) {
		let r = Ft(e, t, n), o = a.length > 0 ? t.nodes.blockGroup.createChecked({}, a) : void 0;
		return t.nodes.blockContainer.createChecked({
			id: i,
			...e.props
		}, o ? [r, o] : r);
	} else if (t.nodes[e.type].isInGroup("bnBlock")) return t.nodes[e.type].create({
		id: i,
		...e.props
	}, a);
	else throw Error(`block type ${e.type} doesn't match blockContent or bnBlock group`);
}
//#endregion
//#region src/api/blockManipulation/commands/updateBlock/updateBlock.ts
var It = (e, t) => ({ tr: n, dispatch: r }) => (r && B(n, e, t), !0);
function B(e, t, r, i, a) {
	let c = s(e.doc.resolve(t)), l = null;
	c.blockNoteType === "table" && (l = Bt(e));
	let u = n(e);
	if (i !== void 0 && a !== void 0 && i > a) throw Error("Invalid replaceFromPos or replaceToPos");
	let d = u.nodes[c.blockNoteType], f = u.nodes[r.type || c.blockNoteType], p = f.isInGroup("bnBlock") ? f : u.nodes.blockContainer;
	if (c.isBlockContainer && f.isInGroup("blockContent")) {
		let t = i !== void 0 && i > c.blockContent.beforePos && i < c.blockContent.afterPos ? i - c.blockContent.beforePos - 1 : void 0, n = a !== void 0 && a > c.blockContent.beforePos && a < c.blockContent.afterPos ? a - c.blockContent.beforePos - 1 : void 0;
		Rt(r, e, c), Lt(r, e, d, f, c, t, n);
	} else if (!c.isBlockContainer && f.isInGroup("bnBlock")) Rt(r, e, c);
	else {
		let t = z({
			children: o(c.bnBlock.node, u).children,
			...r
		}, u);
		t.check(), e.replaceWith(c.bnBlock.beforePos, c.bnBlock.afterPos, t);
		return;
	}
	e.setNodeMarkup(c.bnBlock.beforePos, p, {
		...c.bnBlock.node.attrs,
		...r.props
	}), l && Vt(e, c, l);
}
function Lt(e, t, r, i, a, o, s) {
	let c = n(t), l = "keep";
	if (e.content) if (typeof e.content == "string") l = R([e.content], c, i.name);
	else if (Array.isArray(e.content)) l = R(e.content, c, i.name);
	else if (e.content.type === "tableContent") l = Pt(e.content, c);
	else throw new d(e.content.type);
	else r.spec.content === "" || i.spec.content !== r.spec.content && (l = []);
	if (l === "keep") t.setNodeMarkup(a.blockContent.beforePos, i, {
		...a.blockContent.node.attrs,
		...e.props
	});
	else if (o !== void 0 || s !== void 0) {
		t.setNodeMarkup(a.blockContent.beforePos, i, {
			...a.blockContent.node.attrs,
			...e.props
		});
		let n = a.blockContent.beforePos + 1 + (o ?? 0), r = a.blockContent.beforePos + 1 + (s ?? a.blockContent.node.content.size), c = t.doc.resolve(a.blockContent.beforePos).depth, u = t.doc.resolve(n).depth, d = t.doc.resolve(r).depth;
		t.replace(n, r, new g(h.from(l), u - c - 1, d - c - 1));
	} else t.replaceWith(a.blockContent.beforePos, a.blockContent.afterPos, i.createChecked({
		...a.blockContent.node.attrs,
		...e.props
	}, l));
}
function Rt(e, t, r) {
	let i = n(t);
	if (e.children !== void 0 && e.children.length > 0) {
		let n = e.children.map((e) => {
			let t = z(e, i);
			return t.check(), t;
		});
		if (r.childContainer) t.step(new _(r.childContainer.beforePos + 1, r.childContainer.afterPos - 1, new g(h.from(n), 0, 0)));
		else {
			if (!r.isBlockContainer) throw Error("impossible");
			t.insert(r.blockContent.afterPos, i.nodes.blockGroup.createChecked({}, n));
		}
	}
}
function zt(e, t, r, i, a) {
	let s = typeof t == "string" ? t : t.id, c = O(s, e.doc);
	if (!c) throw Error(`Block with ID ${s} not found`);
	return B(e, c.posBeforeNode, r, i, a), o(e.doc.resolve(c.posBeforeNode + 1).node(), n(e));
}
function Bt(e) {
	let t = "selection" in e ? e.selection : null;
	if (!(t instanceof b)) return null;
	let n = e.doc.resolve(t.head), r = -1, i = -1;
	for (let e = n.depth; e >= 0; e--) {
		let t = n.node(e).type.name;
		if (r < 0 && (t === "tableCell" || t === "tableHeader") && (r = e), t === "table") {
			i = e;
			break;
		}
	}
	if (r < 0 || i < 0) return null;
	let a = n.before(r), o = n.before(i), s = e.doc.nodeAt(o);
	if (!s || s.type.name !== "table") return null;
	let c = pe.get(s), l = a - (o + 1), u = c.map.indexOf(l);
	if (u < 0) return null;
	let d = Math.floor(u / c.width), f = u % c.width, p = a + 1 + 1;
	return {
		row: d,
		col: f,
		offset: Math.max(0, t.head - p)
	};
}
function Vt(e, t, n) {
	if (t.blockNoteType !== "table") return !1;
	let r = -1;
	if (t.isBlockContainer) r = e.mapping.map(t.blockContent.beforePos);
	else {
		let n = e.mapping.map(t.bnBlock.beforePos), i = n + (e.doc.nodeAt(n)?.nodeSize || 0);
		e.doc.nodesBetween(n, i, (e, t) => e.type.name === "table" ? (r = t, !1) : !0);
	}
	let i = r >= 0 ? e.doc.nodeAt(r) : null;
	if (!i || i.type.name !== "table") return !1;
	let a = pe.get(i), o = Math.max(0, Math.min(n.row, a.height - 1)), s = Math.max(0, Math.min(n.col, a.width - 1)), c = o * a.width + s, l = a.map[c];
	if (l == null) return !1;
	let u = r + 1 + l + 1, d = e.doc.nodeAt(u), f = u + 1, p = d ? d.content.size : 0, m = f + Math.max(0, Math.min(n.offset, p));
	return "selection" in e && e.setSelection(b.create(e.doc, m)), !0;
}
//#endregion
//#region src/editor/defaultColors.ts
var V = {
	gray: {
		text: "#9b9a97",
		background: "#ebeced"
	},
	brown: {
		text: "#64473a",
		background: "#e9e5e3"
	},
	red: {
		text: "#e03e3e",
		background: "#fbe4e4"
	},
	orange: {
		text: "#d9730d",
		background: "#f6e9d9"
	},
	yellow: {
		text: "#dfab01",
		background: "#fbf3db"
	},
	green: {
		text: "#4d6461",
		background: "#ddedea"
	},
	blue: {
		text: "#0b6e99",
		background: "#ddebf1"
	},
	purple: {
		text: "#6940a5",
		background: "#eae4f2"
	},
	pink: {
		text: "#ad1a72",
		background: "#f4dfeb"
	}
}, Ht = {
	gray: {
		text: "#bebdb8",
		background: "#9b9a97"
	},
	brown: {
		text: "#8e6552",
		background: "#64473a"
	},
	red: {
		text: "#ec4040",
		background: "#be3434"
	},
	orange: {
		text: "#e3790d",
		background: "#b7600a"
	},
	yellow: {
		text: "#dfab01",
		background: "#b58b00"
	},
	green: {
		text: "#6b8b87",
		background: "#4d6461"
	},
	blue: {
		text: "#0e87bc",
		background: "#0b6e99"
	},
	purple: {
		text: "#8552d7",
		background: "#6940a5"
	},
	pink: {
		text: "#da208f",
		background: "#ad1a72"
	}
}, H = {
	backgroundColor: { default: "default" },
	textColor: { default: "default" },
	textAlignment: {
		default: "left",
		values: [
			"left",
			"center",
			"right",
			"justify"
		]
	}
}, U = (e) => {
	let t = {};
	return e.hasAttribute("data-background-color") ? t.backgroundColor = e.getAttribute("data-background-color") : e.style.backgroundColor && (t.backgroundColor = e.style.backgroundColor), e.hasAttribute("data-text-color") ? t.textColor = e.getAttribute("data-text-color") : e.style.color && (t.textColor = e.style.color), t.textAlignment = H.textAlignment.values.includes(e.style.textAlign) ? e.style.textAlign : void 0, t;
}, W = (e, t) => {
	e.backgroundColor && e.backgroundColor !== H.backgroundColor.default && (t.style.backgroundColor = e.backgroundColor in V ? V[e.backgroundColor].background : e.backgroundColor), e.textColor && e.textColor !== H.textColor.default && (t.style.color = e.textColor in V ? V[e.textColor].text : e.textColor), e.textAlignment && e.textAlignment !== H.textAlignment.default && (t.style.textAlign = e.textAlignment);
}, Ut = (e = "backgroundColor") => ({
	default: H.backgroundColor.default,
	parseHTML: (e) => e.hasAttribute("data-background-color") ? e.getAttribute("data-background-color") : e.style.backgroundColor ? e.style.backgroundColor : H.backgroundColor.default,
	renderHTML: (t) => t[e] === H.backgroundColor.default ? {} : { "data-background-color": t[e] }
}), Wt = (e = "textColor") => ({
	default: H.textColor.default,
	parseHTML: (e) => e.hasAttribute("data-text-color") ? e.getAttribute("data-text-color") : e.style.color ? e.style.color : H.textColor.default,
	renderHTML: (t) => t[e] === H.textColor.default ? {} : { "data-text-color": t[e] }
}), Gt = (e = "textAlignment") => ({
	default: H.textAlignment.default,
	parseHTML: (e) => e.hasAttribute("data-text-alignment") ? e.getAttribute("data-text-alignment") : e.style.textAlign ? e.style.textAlign : H.textAlignment.default,
	renderHTML: (t) => t[e] === H.textAlignment.default ? {} : { "data-text-alignment": t[e] }
}), G = (e, t) => {
	let n = e.querySelector(t);
	if (n) return {
		targetElement: n,
		caption: e.querySelector("figcaption")?.textContent ?? void 0
	};
}, K = p(({ editor: e }) => {
	let t = f(void 0);
	function n() {
		t.setState(void 0);
	}
	return {
		key: "filePanel",
		store: t,
		mount({ signal: t }) {
			let r = e.onChange(n, !1), i = e.onSelectionChange(n, !1);
			t.addEventListener("abort", () => {
				r(), i();
			});
		},
		closeMenu: n,
		showMenu(e) {
			t.setState(e);
		}
	};
}), Kt = (e, t, n) => {
	let r = document.createElement("div");
	r.className = "bn-add-file-button";
	let i = document.createElement("div");
	i.className = "bn-add-file-button-icon", n ? i.appendChild(n) : i.innerHTML = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" fill=\"currentColor\"><path d=\"M3 8L9.00319 2H19.9978C20.5513 2 21 2.45531 21 2.9918V21.0082C21 21.556 20.5551 22 20.0066 22H3.9934C3.44476 22 3 21.5501 3 20.9932V8ZM10 4V9H5V20H19V4H10Z\"></path></svg>", r.appendChild(i);
	let a = document.createElement("p");
	a.className = "bn-add-file-button-text", a.innerHTML = e.type in t.dictionary.file_blocks.add_button_text ? t.dictionary.file_blocks.add_button_text[e.type] : t.dictionary.file_blocks.add_button_text.file, r.appendChild(a);
	let o = (e) => {
		e.preventDefault(), e.stopPropagation();
	}, s = () => {
		t.isEditable && t.getExtension(K)?.showMenu(e.id);
	};
	return r.addEventListener("mousedown", o, !0), r.addEventListener("click", s, !0), {
		dom: r,
		destroy: () => {
			r.removeEventListener("mousedown", o, !0), r.removeEventListener("click", s, !0);
		}
	};
}, qt = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" fill=\"currentColor\"><path d=\"M3 8L9.00319 2H19.9978C20.5513 2 21 2.45531 21 2.9918V21.0082C21 21.556 20.5551 22 20.0066 22H3.9934C3.44476 22 3 21.5501 3 20.9932V8ZM10 4V9H5V20H19V4H10Z\"></path></svg>", Jt = (e) => {
	let t = document.createElement("div");
	t.className = "bn-file-name-with-icon";
	let n = document.createElement("div");
	n.className = "bn-file-icon", n.innerHTML = qt, t.appendChild(n);
	let r = document.createElement("p");
	return r.className = "bn-file-name", r.textContent = e.props.name, t.appendChild(r), { dom: t };
}, q = (e, t, n, r) => {
	let i = e.props.url !== "" && !!e.props.caption, a = document.createElement(i ? "figure" : "div");
	if (a.className = "bn-file-block-content-wrapper", e.props.url === "") {
		let n = Kt(e, t, r);
		a.appendChild(n.dom);
		let i = t.onUploadStart((t) => {
			if (t === e.id) {
				a.removeChild(n.dom);
				let e = document.createElement("div");
				e.className = "bn-file-loading-preview", e.textContent = "Loading...", a.appendChild(e);
			}
		});
		return {
			dom: a,
			destroy: () => {
				i(), n.destroy();
			}
		};
	}
	let o = { dom: a };
	if (e.props.showPreview === !1 || !n) {
		let t = Jt(e);
		a.appendChild(t.dom), o.destroy = () => {
			t.destroy?.();
		};
	} else a.appendChild(n.dom);
	if (e.props.caption) {
		let t = document.createElement("figcaption");
		t.className = "bn-file-caption", t.textContent = e.props.caption, a.appendChild(t);
	}
	return o;
}, Yt = (e, t) => {
	let n = document.createElement("figure"), r = document.createElement("figcaption");
	return r.textContent = t, n.appendChild(e), n.appendChild(r), { dom: n };
}, J = (e, t) => {
	let n = document.createElement("div"), r = document.createElement("p");
	return r.textContent = t, n.appendChild(e), n.appendChild(r), { dom: n };
}, Xt = (e) => ({ url: e.src || void 0 }), Zt = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" fill=\"currentColor\"><path d=\"M2 16.0001H5.88889L11.1834 20.3319C11.2727 20.405 11.3846 20.4449 11.5 20.4449C11.7761 20.4449 12 20.2211 12 19.9449V4.05519C12 3.93977 11.9601 3.8279 11.887 3.73857C11.7121 3.52485 11.3971 3.49335 11.1834 3.66821L5.88889 8.00007H2C1.44772 8.00007 1 8.44778 1 9.00007V15.0001C1 15.5524 1.44772 16.0001 2 16.0001ZM23 12C23 15.292 21.5539 18.2463 19.2622 20.2622L17.8445 18.8444C19.7758 17.1937 21 14.7398 21 12C21 9.26016 19.7758 6.80629 17.8445 5.15557L19.2622 3.73779C21.5539 5.75368 23 8.70795 23 12ZM18 12C18 10.0883 17.106 8.38548 15.7133 7.28673L14.2842 8.71584C15.3213 9.43855 16 10.64 16 12C16 13.36 15.3213 14.5614 14.2842 15.2841L15.7133 16.7132C17.106 15.6145 18 13.9116 18 12Z\"></path></svg>", Qt = j((e) => ({
	type: "audio",
	propSchema: {
		backgroundColor: H.backgroundColor,
		name: { default: "" },
		url: { default: "" },
		caption: { default: "" },
		showPreview: { default: !0 }
	},
	content: "none"
})), $t = (e = {}) => (e) => {
	if (e.tagName === "AUDIO") {
		if (e.closest("figure")) return;
		let { backgroundColor: t } = U(e);
		return {
			...Xt(e),
			backgroundColor: t
		};
	}
	if (e.tagName === "FIGURE") {
		let t = G(e, "audio");
		if (!t) return;
		let { targetElement: n, caption: r } = t, { backgroundColor: i } = U(e);
		return {
			...Xt(n),
			backgroundColor: i,
			caption: r
		};
	}
}, en = (e = {}) => (t, n) => {
	let r = document.createElement("div");
	r.innerHTML = e.icon ?? "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" fill=\"currentColor\"><path d=\"M2 16.0001H5.88889L11.1834 20.3319C11.2727 20.405 11.3846 20.4449 11.5 20.4449C11.7761 20.4449 12 20.2211 12 19.9449V4.05519C12 3.93977 11.9601 3.8279 11.887 3.73857C11.7121 3.52485 11.3971 3.49335 11.1834 3.66821L5.88889 8.00007H2C1.44772 8.00007 1 8.44778 1 9.00007V15.0001C1 15.5524 1.44772 16.0001 2 16.0001ZM23 12C23 15.292 21.5539 18.2463 19.2622 20.2622L17.8445 18.8444C19.7758 17.1937 21 14.7398 21 12C21 9.26016 19.7758 6.80629 17.8445 5.15557L19.2622 3.73779C21.5539 5.75368 23 8.70795 23 12ZM18 12C18 10.0883 17.106 8.38548 15.7133 7.28673L14.2842 8.71584C15.3213 9.43855 16 10.64 16 12C16 13.36 15.3213 14.5614 14.2842 15.2841L15.7133 16.7132C17.106 15.6145 18 13.9116 18 12Z\"></path></svg>";
	let i = document.createElement("audio");
	return i.className = "bn-audio", n.resolveFileUrl ? n.resolveFileUrl(t.props.url).then((e) => {
		i.src = e;
	}) : i.src = t.props.url, i.controls = !0, i.contentEditable = "false", i.draggable = !1, q(t, n, { dom: i }, r.firstElementChild);
}, tn = (e = {}) => (e, t) => {
	if (!e.props.url) return { dom: document.createElement("audio") };
	let n;
	return e.props.showPreview ? (n = document.createElement("audio"), n.src = e.props.url) : (n = document.createElement("a"), n.href = e.props.url, n.textContent = e.props.name || e.props.url), e.props.caption ? e.props.showPreview ? Yt(n, e.props.caption) : J(n, e.props.caption) : { dom: n };
}, nn = M(Qt, (e) => ({
	meta: { fileBlockAccept: ["audio/*"] },
	parse: $t(e),
	render: en(e),
	toExternalHTML: tn(e),
	runsBefore: ["file"]
})), rn = Symbol.for("blocknote.shikiParser"), an = Symbol.for("blocknote.shikiHighlighterPromise");
function on(e) {
	let t = globalThis, n, r, i = !1;
	return Se({
		parser: (a) => {
			if (!e.createHighlighter) return process.env.NODE_ENV === "development" && !i && (console.log("For syntax highlighting of code blocks, you must provide a `createCodeBlockSpec({ createHighlighter: () => ... })` function"), i = !0), [];
			if (!n) return t[an] = t[an] || e.createHighlighter(), t[an].then((e) => {
				n = e;
			});
			let o = ln(e, a.language);
			return !o || o === "text" || o === "none" || o === "plaintext" || o === "txt" ? [] : n.getLoadedLanguages().includes(o) ? (r || (r = t[rn] || Ce(n), t[rn] = r), r(a)) : n.loadLanguage(o);
		},
		languageExtractor: (e) => e.attrs.language,
		nodeTypes: ["codeBlock"]
	});
}
//#endregion
//#region src/blocks/Code/block.ts
var sn = j(({ defaultLanguage: e = "text" }) => ({
	type: "codeBlock",
	propSchema: { language: { default: e } },
	content: "inline"
})), cn = M(sn, (e) => ({
	meta: {
		code: !0,
		defining: !0,
		isolating: !1
	},
	parse: (e) => {
		if (e.tagName !== "PRE" || e.childElementCount !== 1 || e.firstElementChild?.tagName !== "CODE") return;
		let t = e.firstElementChild;
		return { language: t.getAttribute("data-language") || t.className.split(" ").find((e) => e.includes("language-"))?.replace("language-", "") };
	},
	parseContent: ({ el: e, schema: t }) => {
		let n = le.fromSchema(t), r = e.firstElementChild;
		return n.parse(r, {
			preserveWhitespace: "full",
			topNode: t.nodes.codeBlock.create()
		}).content;
	},
	render(t, n) {
		let r = document.createDocumentFragment(), i = document.createElement("pre"), a = document.createElement("code");
		i.appendChild(a);
		let o;
		if (e.supportedLanguages) {
			let i = document.createElement("select");
			if (Object.entries(e.supportedLanguages ?? {}).forEach(([e, { name: t }]) => {
				let n = document.createElement("option");
				n.value = e, n.text = t, i.appendChild(n);
			}), i.value = t.props.language || e.defaultLanguage || "text", n.isEditable) {
				let e = (e) => {
					let r = e.target.value;
					n.updateBlock(t.id, { props: { language: r } });
				};
				i.addEventListener("change", e), o = () => i.removeEventListener("change", e);
			} else i.disabled = !0;
			let a = document.createElement("div");
			a.contentEditable = "false", a.appendChild(i), r.appendChild(a);
		}
		return r.appendChild(i), {
			dom: r,
			contentDOM: a,
			destroy: () => {
				o?.();
			}
		};
	},
	toExternalHTML(e) {
		let t = document.createElement("pre"), n = document.createElement("code");
		return n.className = `language-${e.props.language}`, n.dataset.language = e.props.language, t.appendChild(n), {
			dom: t,
			contentDOM: n
		};
	}
}), (e) => [p({
	key: "code-block-highlighter",
	prosemirrorPlugins: [on(e)]
}), p({
	key: "code-block-keyboard-shortcuts",
	keyboardShortcuts: {
		Delete: ({ editor: e }) => e.transact((t) => {
			let { block: n } = e.getTextCursorPosition();
			if (n.type !== "codeBlock") return !1;
			let { $from: r } = t.selection;
			return r.parent.textContent ? !1 : (e.removeBlocks([n]), !0);
		}),
		Tab: ({ editor: t }) => e.indentLineWithTab === !1 ? !1 : t.transact((e) => {
			let { block: n } = t.getTextCursorPosition();
			return n.type === "codeBlock" ? (e.insertText("  "), !0) : !1;
		}),
		Enter: ({ editor: e }) => e.transact((t) => {
			let { block: n, nextBlock: r } = e.getTextCursorPosition();
			if (n.type !== "codeBlock") return !1;
			let { $from: i } = t.selection, a = i.parentOffset === i.parent.nodeSize - 2, o = i.parent.textContent.endsWith("\n\n");
			if (a && o) {
				if (t.delete(i.pos - 2, i.pos), r) return e.setTextCursorPosition(r, "start"), !0;
				let [a] = e.insertBlocks([{ type: "paragraph" }], n, "after");
				return e.setTextCursorPosition(a, "start"), !0;
			}
			return t.insertText("\n"), !0;
		}),
		"Shift-Enter": ({ editor: e }) => e.transact(() => {
			let { block: t } = e.getTextCursorPosition();
			if (t.type !== "codeBlock") return !1;
			let [n] = e.insertBlocks([{ type: "paragraph" }], t, "after");
			return e.setTextCursorPosition(n, "start"), !0;
		})
	},
	inputRules: [{
		find: /^```(.*?)\s$/,
		replace: ({ match: t }) => {
			let n = t[1].trim();
			return {
				type: "codeBlock",
				props: { language: { language: ln(e, n) ?? n }.language },
				content: []
			};
		}
	}]
})]);
function ln(e, t) {
	return Object.entries(e.supportedLanguages ?? {}).find(([e, { aliases: n }]) => n?.includes(t) || e === t)?.[0];
}
//#endregion
//#region src/blocks/Divider/block.ts
var un = j(() => ({
	type: "divider",
	propSchema: {},
	content: "none"
})), dn = M(un, {
	meta: { isolating: !1 },
	parse(e) {
		if (e.tagName === "HR") return {};
	},
	render() {
		return { dom: document.createElement("hr") };
	}
}, [p({
	key: "divider-block-shortcuts",
	inputRules: [{
		find: RegExp("^---$"),
		replace() {
			return {
				type: "divider",
				props: {},
				content: []
			};
		}
	}]
})]), fn = (e) => ({ url: e.src || void 0 }), pn = j(() => ({
	type: "file",
	propSchema: {
		backgroundColor: H.backgroundColor,
		name: { default: "" },
		url: { default: "" },
		caption: { default: "" }
	},
	content: "none"
})), mn = () => (e) => {
	if (e.tagName === "EMBED") {
		if (e.closest("figure")) return;
		let { backgroundColor: t } = U(e);
		return {
			...fn(e),
			backgroundColor: t
		};
	}
	if (e.tagName === "FIGURE") {
		let t = G(e, "embed");
		if (!t) return;
		let { targetElement: n, caption: r } = t, { backgroundColor: i } = U(e);
		return {
			...fn(n),
			backgroundColor: i,
			caption: r
		};
	}
}, hn = M(pn, {
	meta: { fileBlockAccept: ["*/*"] },
	parse: mn(),
	render(e, t) {
		return q(e, t);
	},
	toExternalHTML(e) {
		if (!e.props.url) return { dom: document.createElement("embed") };
		let t = document.createElement("a");
		return t.href = e.props.url, t.textContent = e.props.name || e.props.url, e.props.caption ? J(t, e.props.caption) : { dom: t };
	}
});
//#endregion
//#region src/blocks/getDetailsContent.ts
function gn(e, t, n) {
	let r = m.fromSchema(t), i = e.querySelector(":scope > summary"), a;
	if (i) {
		let e = i.cloneNode(!0);
		ze(e), a = r.parse(e, {
			topNode: t.nodes.paragraph.create(),
			preserveWhitespace: !0
		}).content;
	} else a = h.empty;
	let o = document.createElement("div");
	o.setAttribute("data-node-type", "blockGroup");
	let s = !1;
	for (let t of Array.from(e.childNodes)) t.tagName !== "SUMMARY" && (t.nodeType === 3 && !t.textContent?.trim() || (s = !0, o.appendChild(t.cloneNode(!0))));
	let c = t.nodes[n].create({}, a);
	if (!s) return c.content;
	let l = r.parse(o, { topNode: t.nodes.blockGroup.create() });
	return l.content.size > 0 ? c.content.addToEnd(l) : c.content;
}
//#endregion
//#region src/blocks/ToggleWrapper/createToggleWrapper.ts
var _n = {
	set: (e, t) => window.localStorage.setItem(`toggle-${e.id}`, t ? "true" : "false"),
	get: (e) => window.localStorage.getItem(`toggle-${e.id}`) === "true"
}, vn = (e, t, n, r = _n) => {
	if ("isToggleable" in e.props && !e.props.isToggleable) return { dom: n };
	let i = document.createElement("div"), a = document.createElement("div");
	a.className = "bn-toggle-wrapper";
	let o = document.createElement("button");
	o.className = "bn-toggle-button", o.type = "button", o.innerHTML = "<svg xmlns=\"http://www.w3.org/2000/svg\" height=\"24px\" viewBox=\"0 -960 960 960\" width=\"24px\" fill=\"CURRENTCOLOR\"><path d=\"M320-200v-560l440 280-440 280Z\"/></svg>";
	let s = (e) => e.preventDefault();
	o.addEventListener("mousedown", s);
	let c = () => {
		a.getAttribute("data-show-children") === "true" ? (a.setAttribute("data-show-children", "false"), r.set(t.getBlock(e), !1), i.contains(l) && i.removeChild(l)) : (a.setAttribute("data-show-children", "true"), r.set(t.getBlock(e), !0), t.isEditable && t.getBlock(e)?.children.length === 0 && !i.contains(l) && i.appendChild(l));
	};
	o.addEventListener("click", c), a.appendChild(o), a.appendChild(n);
	let l = document.createElement("button");
	l.className = "bn-toggle-add-block-button", l.type = "button", l.textContent = t.dictionary.toggle_blocks.add_block_button;
	let u = (e) => e.preventDefault();
	l.addEventListener("mousedown", u);
	let d = () => {
		t.transact(() => {
			let n = t.updateBlock(e, { children: [{}] });
			t.setTextCursorPosition(n.children[0].id, "end"), t.focus();
		});
	};
	l.addEventListener("click", d), i.appendChild(a);
	let f = e.children.length, p = t.onChange(() => {
		let n = t.getBlock(e)?.children.length ?? 0;
		n > f ? (a.getAttribute("data-show-children") === "false" && (a.setAttribute("data-show-children", "true"), r.set(t.getBlock(e), !0)), i.contains(l) && i.removeChild(l)) : n === 0 && n < f && (a.getAttribute("data-show-children") === "true" && (a.setAttribute("data-show-children", "false"), r.set(t.getBlock(e), !1)), i.contains(l) && i.removeChild(l)), f = n;
	});
	return r.get(e) ? (a.setAttribute("data-show-children", "true"), t.isEditable && e.children.length === 0 && i.appendChild(l)) : a.setAttribute("data-show-children", "false"), {
		dom: i,
		ignoreMutation: (e) => e instanceof MutationRecord && (e.type === "attributes" && e.target === a && e.attributeName === "data-show-children" || e.type === "childList" && (e.addedNodes[0] === l || e.removedNodes[0] === l)),
		destroy: () => {
			o.removeEventListener("mousedown", s), o.removeEventListener("click", c), l.removeEventListener("mousedown", u), l.removeEventListener("click", d), p?.();
		}
	};
}, yn = [
	1,
	2,
	3,
	4,
	5,
	6
], bn = (e) => ({ editor: t }) => {
	let n = t.getTextCursorPosition();
	return t.schema.blockSchema[n.block.type].content === "inline" ? (t.updateBlock(n.block, {
		type: "heading",
		props: { level: e }
	}), !0) : !1;
}, xn = j(({ defaultLevel: e = 1, levels: t = yn, allowToggleHeadings: n = !0 } = {}) => ({
	type: "heading",
	propSchema: {
		...H,
		level: {
			default: e,
			values: t
		},
		...n ? { isToggleable: {
			default: !1,
			optional: !0
		} } : {}
	},
	content: "inline"
})), Sn = M(xn, ({ allowToggleHeadings: e = !0 } = {}) => ({
	meta: { isolating: !1 },
	parse(t) {
		if (e && t.tagName === "DETAILS") {
			let e = t.querySelector(":scope > summary");
			if (!e) return;
			let n = e.querySelector("h1, h2, h3, h4, h5, h6");
			return n ? {
				...U(n),
				level: parseInt(n.tagName[1]),
				isToggleable: !0
			} : void 0;
		}
		let n;
		switch (t.tagName) {
			case "H1":
				n = 1;
				break;
			case "H2":
				n = 2;
				break;
			case "H3":
				n = 3;
				break;
			case "H4":
				n = 4;
				break;
			case "H5":
				n = 5;
				break;
			case "H6":
				n = 6;
				break;
			default: return;
		}
		return {
			...U(t),
			level: n
		};
	},
	...e ? { parseContent: ({ el: e, schema: t }) => {
		if (e.tagName === "DETAILS") return gn(e, t, "heading");
	} } : {},
	runsBefore: ["toggleListItem"],
	render(t, n) {
		let r = document.createElement(`h${t.props.level}`);
		return e ? {
			...vn(t, n, r),
			contentDOM: r
		} : {
			dom: r,
			contentDOM: r
		};
	},
	toExternalHTML(t) {
		let n = document.createElement(`h${t.props.level}`);
		if (W(t.props, n), e && t.props.isToggleable) {
			let e = document.createElement("details");
			e.setAttribute("open", "");
			let t = document.createElement("summary");
			return t.appendChild(n), e.appendChild(t), {
				dom: e,
				contentDOM: n,
				childrenDOM: e
			};
		}
		return {
			dom: n,
			contentDOM: n
		};
	}
}), ({ levels: e = yn } = {}) => [p({
	key: "heading-shortcuts",
	keyboardShortcuts: Object.fromEntries(e.map((e) => [`Mod-Alt-${e}`, bn(e)]) ?? []),
	inputRules: e.map((e) => ({
		find: RegExp(`^(#{${e}})\\s$`),
		replace({ match: e }) {
			return {
				type: "heading",
				props: { level: e[1].length }
			};
		}
	}))
})]), Cn = (e, t, n, r, i) => {
	let { dom: a, destroy: o } = q(e, t, n, i), s = a;
	s.style.position = "relative", e.props.url && e.props.showPreview && (e.props.previewWidth ? s.style.width = `${e.props.previewWidth}px` : s.style.width = "fit-content");
	let c = document.createElement("div");
	c.className = "bn-resize-handle", c.style.left = "4px", c.style.display = "none", r.appendChild(c);
	let l = document.createElement("div");
	l.className = "bn-resize-handle", l.style.right = "4px", l.style.display = "none", r.appendChild(l);
	let u = document.createElement("div");
	u.style.position = "absolute", u.style.height = "100%", u.style.width = "100%";
	let d, f = e.props.previewWidth, p = (n) => {
		if (!d) {
			t.isEditable || (c.style.display = "none", l.style.display = "none");
			return;
		}
		let r, i = "touches" in n ? n.touches[0].clientX : n.clientX;
		r = e.props.textAlignment === "center" ? d.handleUsed === "left" ? d.initialWidth + (d.initialClientX - i) * 2 : d.initialWidth + (i - d.initialClientX) * 2 : d.handleUsed === "left" ? d.initialWidth + d.initialClientX - i : d.initialWidth + i - d.initialClientX, f = Math.min(Math.max(r, 64), t.domElement?.firstElementChild?.clientWidth || Number.MAX_VALUE), s.style.width = `${f}px`;
	}, m = (n) => {
		(!n.target || !s.contains(n.target) || !t.isEditable) && (c.style.display = "none", l.style.display = "none"), d && (d = void 0, s.contains(u) && s.removeChild(u), t.updateBlock(e, { props: { previewWidth: f } }));
	}, h = () => {
		t.isEditable && (c.style.display = "", l.style.display = "");
	}, g = (e) => {
		e.relatedTarget === c || e.relatedTarget === l || d || t.isEditable && (c.style.display = "none", l.style.display = "none");
	}, _ = (e) => {
		e.preventDefault(), s.contains(u) || s.appendChild(u);
		let t = "touches" in e ? e.touches[0].clientX : e.clientX;
		d = {
			handleUsed: "left",
			initialWidth: s.clientWidth,
			initialClientX: t
		};
	}, v = (e) => {
		e.preventDefault(), s.contains(u) || s.appendChild(u);
		let t = "touches" in e ? e.touches[0].clientX : e.clientX;
		d = {
			handleUsed: "right",
			initialWidth: s.clientWidth,
			initialClientX: t
		};
	};
	return window.addEventListener("mousemove", p), window.addEventListener("touchmove", p), window.addEventListener("mouseup", m), window.addEventListener("touchend", m), s.addEventListener("mouseenter", h), s.addEventListener("mouseleave", g), c.addEventListener("mousedown", _), c.addEventListener("touchstart", _), l.addEventListener("mousedown", v), l.addEventListener("touchstart", v), {
		dom: s,
		destroy: () => {
			o?.(), window.removeEventListener("mousemove", p), window.removeEventListener("touchmove", p), window.removeEventListener("mouseup", m), window.removeEventListener("touchend", m), s.removeEventListener("mouseenter", h), s.removeEventListener("mouseleave", g), c.removeEventListener("mousedown", _), c.removeEventListener("touchstart", _), l.removeEventListener("mousedown", v), l.removeEventListener("touchstart", v);
		}
	};
}, wn = (e) => ({
	url: e.src || void 0,
	previewWidth: e.width || void 0,
	name: e.alt || void 0
}), Tn = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" fill=\"currentColor\"><path d=\"M5 11.1005L7 9.1005L12.5 14.6005L16 11.1005L19 14.1005V5H5V11.1005ZM4 3H20C20.5523 3 21 3.44772 21 4V20C21 20.5523 20.5523 21 20 21H4C3.44772 21 3 20.5523 3 20V4C3 3.44772 3.44772 3 4 3ZM15.5 10C14.6716 10 14 9.32843 14 8.5C14 7.67157 14.6716 7 15.5 7C16.3284 7 17 7.67157 17 8.5C17 9.32843 16.3284 10 15.5 10Z\"></path></svg>", En = j((e = {}) => ({
	type: "image",
	propSchema: {
		textAlignment: H.textAlignment,
		backgroundColor: H.backgroundColor,
		name: { default: "" },
		url: { default: "" },
		caption: { default: "" },
		showPreview: { default: !0 },
		previewWidth: {
			default: void 0,
			type: "number"
		}
	},
	content: "none"
})), Dn = (e = {}) => (e) => {
	if (e.tagName === "IMG") {
		if (e.closest("figure")) return;
		let { backgroundColor: t } = U(e);
		return {
			...wn(e),
			backgroundColor: t
		};
	}
	if (e.tagName === "FIGURE") {
		let t = G(e, "img");
		if (!t) return;
		let { targetElement: n, caption: r } = t, { backgroundColor: i } = U(e);
		return {
			...wn(n),
			backgroundColor: i,
			caption: r
		};
	}
}, On = (e = {}) => (t, n) => {
	let r = document.createElement("div");
	r.innerHTML = e.icon ?? "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" fill=\"currentColor\"><path d=\"M5 11.1005L7 9.1005L12.5 14.6005L16 11.1005L19 14.1005V5H5V11.1005ZM4 3H20C20.5523 3 21 3.44772 21 4V20C21 20.5523 20.5523 21 20 21H4C3.44772 21 3 20.5523 3 20V4C3 3.44772 3.44772 3 4 3ZM15.5 10C14.6716 10 14 9.32843 14 8.5C14 7.67157 14.6716 7 15.5 7C16.3284 7 17 7.67157 17 8.5C17 9.32843 16.3284 10 15.5 10Z\"></path></svg>";
	let i = document.createElement("div");
	i.className = "bn-visual-media-wrapper";
	let a = document.createElement("img");
	return a.className = "bn-visual-media", n.resolveFileUrl ? n.resolveFileUrl(t.props.url).then((e) => {
		a.src = e;
	}) : a.src = t.props.url, a.alt = t.props.name || "", a.contentEditable = "false", a.draggable = !1, t.props.previewWidth && (a.width = t.props.previewWidth), i.appendChild(a), Cn(t, n, { dom: i }, i, r.firstElementChild);
}, kn = (e = {}) => (e, t) => {
	if (!e.props.url) return { dom: document.createElement("img") };
	let n;
	return e.props.showPreview ? (n = document.createElement("img"), n.src = e.props.url, n.alt = e.props.name || "", e.props.previewWidth && (n.width = e.props.previewWidth)) : (n = document.createElement("a"), n.href = e.props.url, n.textContent = e.props.name || e.props.url), e.props.caption ? e.props.showPreview ? Yt(n, e.props.caption) : J(n, e.props.caption) : { dom: n };
}, An = M(En, (e) => ({
	meta: { fileBlockAccept: ["image/*"] },
	parse: Dn(e),
	render: On(e),
	toExternalHTML: kn(e),
	runsBefore: ["file"]
})), jn = (e, t, n) => ({ state: r, dispatch: i }) => i ? Mn(r.tr, e, t, n) : !0, Mn = (e, t, r, i) => {
	let a = c(l(e.doc, t));
	if (!a.isBlockContainer) return !1;
	let o = n(e), s = [{
		type: a.bnBlock.node.type,
		attrs: i ? {
			...a.bnBlock.node.attrs,
			id: void 0
		} : {}
	}, {
		type: r ? a.blockContent.node.type : o.nodes.paragraph,
		attrs: i ? { ...a.blockContent.node.attrs } : {}
	}];
	return e.split(t, 2, s), !0;
}, Y = (e, t) => {
	let { blockInfo: n, selectionEmpty: r } = e.transact((e) => ({
		blockInfo: i(e),
		selectionEmpty: e.selection.anchor === e.selection.head
	}));
	if (!n.isBlockContainer) return !1;
	let { bnBlock: a, blockContent: o } = n;
	return o.node.type.name !== t || !r ? !1 : o.node.childCount === 0 ? (e.transact((e) => {
		B(e, a.beforePos, {
			type: "paragraph",
			props: {}
		});
	}), !0) : o.node.childCount > 0 ? e.transact((e) => (e.deleteSelection(), Mn(e, e.selection.from, !0))) : !1;
};
//#endregion
//#region src/blocks/ListItem/getListItemContent.ts
function Nn(e, t, n) {
	let r = m.fromSchema(t), i = e, a = document.createElement("div");
	a.setAttribute("data-node-type", "blockGroup");
	for (let e of Array.from(i.childNodes)) a.appendChild(e.cloneNode(!0));
	let o = r.parse(a, { topNode: t.nodes.blockGroup.create() });
	o.firstChild?.firstChild?.type.name === "checkListItem" && (o = o.copy(o.content.cut(o.firstChild.firstChild.nodeSize + 2)));
	let s = o.firstChild?.firstChild;
	if (!s?.isTextblock) return h.from(o);
	let c = t.nodes[n].create({}, s.content), l = o.content.cut(s.nodeSize + 2);
	if (l.size > 0) {
		let e = o.copy(l);
		return c.content.addToEnd(e);
	}
	return c.content;
}
//#endregion
//#region src/blocks/ListItem/BulletListItem/block.ts
var Pn = j(() => ({
	type: "bulletListItem",
	propSchema: { ...H },
	content: "inline"
})), Fn = M(Pn, {
	meta: { isolating: !1 },
	parse(e) {
		if (e.tagName !== "LI") return;
		let t = e.parentElement;
		if (t === null || t.tagName === "UL" || t.tagName === "DIV" && t.parentElement?.tagName === "UL" || !e.closest("ul, ol")) return U(e);
	},
	parseContent: ({ el: e, schema: t }) => Nn(e, t, "bulletListItem"),
	render() {
		let e = document.createElement("p");
		return {
			dom: e,
			contentDOM: e
		};
	},
	toExternalHTML(e) {
		let t = document.createElement("li"), n = document.createElement("p");
		return W(e.props, t), t.appendChild(n), {
			dom: t,
			contentDOM: n
		};
	}
}, [p({
	key: "bullet-list-item-shortcuts",
	keyboardShortcuts: {
		Enter: ({ editor: e }) => Y(e, "bulletListItem"),
		"Mod-Shift-8": ({ editor: e }) => {
			let t = e.getTextCursorPosition();
			return e.schema.blockSchema[t.block.type].content === "inline" ? (e.updateBlock(t.block, {
				type: "bulletListItem",
				props: {}
			}), !0) : !1;
		}
	},
	inputRules: [{
		find: /^\s?[-+*]\s$/,
		replace({ editor: e }) {
			if (a(e.prosemirrorState).blockNoteType !== "heading") return {
				type: "bulletListItem",
				props: {}
			};
		}
	}]
})]), In = j(() => ({
	type: "checkListItem",
	propSchema: {
		...H,
		checked: {
			default: !1,
			type: "boolean"
		}
	},
	content: "inline"
})), Ln = M(In, {
	meta: { isolating: !1 },
	parse(e) {
		if (e.tagName === "input") return e.closest("[data-content-type]") || e.closest("li") ? void 0 : e.type === "checkbox" ? { checked: e.checked } : void 0;
		if (e.tagName !== "LI") return;
		let t = e.parentElement;
		if (t !== null && (t.tagName === "UL" || t.tagName === "DIV" && t.parentElement?.tagName === "UL")) {
			let t = e.querySelector("input[type=checkbox]") || null;
			return t === null ? void 0 : {
				...U(e),
				checked: t.checked
			};
		}
	},
	parseContent: ({ el: e, schema: t }) => Nn(e, t, "checkListItem"),
	render(e, t) {
		let n = document.createDocumentFragment(), r = document.createElement("input");
		r.type = "checkbox", r.checked = e.props.checked, e.props.checked && r.setAttribute("checked", ""), r.disabled = !t.isEditable, r.addEventListener("change", () => {
			t.isEditable && t.updateBlock(e, { props: { checked: !e.props.checked } });
		});
		let i = document.createElement("p"), a = document.createElement("div");
		return a.contentEditable = "false", a.appendChild(r), n.appendChild(a), n.appendChild(i), {
			dom: n,
			contentDOM: i
		};
	},
	toExternalHTML(e) {
		let t = document.createElement("li"), n = document.createElement("input");
		n.type = "checkbox", n.checked = e.props.checked, e.props.checked && n.setAttribute("checked", "");
		let r = document.createElement("p");
		return W(e.props, t), t.appendChild(n), t.appendChild(r), {
			dom: t,
			contentDOM: r
		};
	},
	runsBefore: ["bulletListItem"]
}, [p({
	key: "check-list-item-shortcuts",
	keyboardShortcuts: {
		Enter: ({ editor: e }) => Y(e, "checkListItem"),
		"Mod-Shift-9": ({ editor: e }) => {
			let t = e.getTextCursorPosition();
			return e.schema.blockSchema[t.block.type].content === "inline" ? (e.updateBlock(t.block, {
				type: "checkListItem",
				props: {}
			}), !0) : !1;
		}
	},
	inputRules: [{
		find: /^\s?\[\s*\]\s$/,
		replace() {
			return {
				type: "checkListItem",
				props: { checked: !1 }
			};
		}
	}, {
		find: /^\s?\[[Xx]\]\s$/,
		replace() {
			return {
				type: "checkListItem",
				props: { checked: !0 }
			};
		}
	}]
})]);
//#endregion
//#region src/blocks/ListItem/NumberedListItem/IndexingPlugin.ts
function Rn(e, t, n, r) {
	let i = !!e.firstChild.attrs.start, a = c({
		posBeforeNode: t,
		node: e
	});
	if (!a.isBlockContainer) throw Error("impossible");
	let o = n.doc.resolve(a.bnBlock.beforePos).nodeBefore, s = o ? r.get(o) : void 0;
	if (s !== void 0) {
		let t = s + 1;
		return r.set(e, t), {
			index: t,
			isFirst: !1,
			hasStart: i
		};
	}
	let l = [{
		node: e,
		pos: t
	}], u = o, d = a.bnBlock.beforePos;
	for (; u && r.get(u) === void 0;) {
		let e = c({
			posBeforeNode: d - u.nodeSize,
			node: u
		});
		if (e.blockNoteType !== "numberedListItem") break;
		l.push({
			node: u,
			pos: d - u.nodeSize
		});
		let t = n.doc.resolve(e.bnBlock.beforePos).nodeBefore;
		d = e.bnBlock.beforePos, u = t;
	}
	let f, p, m = l[l.length - 1], h = c({
		posBeforeNode: m.pos,
		node: m.node
	});
	if (!h.isBlockContainer) throw Error("impossible");
	let g = n.doc.resolve(h.bnBlock.beforePos).nodeBefore, _ = g ? r.get(g) : void 0;
	_ === void 0 ? (f = (m.node.firstChild.attrs.start || 1) - 1, p = !0) : (f = _, p = !1);
	for (let e = l.length - 1; e >= 0; e--) {
		let t = l[e];
		p && e < l.length - 1 && (p = !1), f++, r.set(t.node, f);
	}
	return {
		index: f,
		isFirst: l.length === 1 ? p || _ === void 0 : !1,
		hasStart: i
	};
}
function zn(e, t) {
	let n = /* @__PURE__ */ new Map(), r = t.decorations.map(e.mapping, e.doc), i = e.changedRange() ?? {
		from: 0,
		to: e.doc.nodeSize - 2
	}, a = [], o = /* @__PURE__ */ new Set();
	e.doc.nodesBetween(i.from, e.doc.nodeSize - 2, (t, s, c) => {
		if (c && o.has(c)) return !1;
		if (t.type.name === "blockContainer" && t.firstChild.type.name === "numberedListItem") {
			let { index: l, isFirst: u, hasStart: d } = Rn(t, s, e, n), f = e.doc.nodeAt(s + 1);
			if (r.find(s + 1, s + 1 + f.nodeSize, (e) => e.index === l && e.isFirst === u && e.hasStart === d).length === 0) a.push(Ee.node(s + 1, s + 1 + f.nodeSize, { "data-index": l.toString() }, {
				index: l,
				isFirst: u,
				hasStart: d
			}));
			else if (s >= i.to && c) return o.add(c), !1;
		}
	});
	let s = a.flatMap((e) => r.find(e.from, e.to));
	return { decorations: r.remove(s).add(e.doc, a) };
}
var Bn = () => new we({
	key: new Te("numbered-list-indexing-decorations"),
	state: {
		init(e, t) {
			return zn(t.tr, { decorations: De.empty });
		},
		apply(e, t) {
			return !e.docChanged && t.decorations ? t : zn(e, t);
		}
	},
	props: { decorations(e) {
		return this.getState(e)?.decorations ?? De.empty;
	} }
}), Vn = j(() => ({
	type: "numberedListItem",
	propSchema: {
		...H,
		start: {
			default: void 0,
			type: "number"
		}
	},
	content: "inline"
})), Hn = M(Vn, {
	meta: { isolating: !1 },
	parse(e) {
		if (e.tagName !== "LI") return;
		let t = e.parentElement;
		if (t !== null && (t.tagName === "OL" || t.tagName === "DIV" && t.parentElement?.tagName === "OL")) {
			let n = parseInt(t.getAttribute("start") || "1"), r = U(e);
			return e.previousElementSibling || n === 1 ? r : {
				...r,
				start: n
			};
		}
	},
	parseContent: ({ el: e, schema: t }) => Nn(e, t, "numberedListItem"),
	render() {
		let e = document.createElement("p");
		return {
			dom: e,
			contentDOM: e
		};
	},
	toExternalHTML(e) {
		let t = document.createElement("li"), n = document.createElement("p");
		return W(e.props, t), t.appendChild(n), {
			dom: t,
			contentDOM: n
		};
	}
}, [p({
	key: "numbered-list-item-shortcuts",
	inputRules: [{
		find: /^\s?(\d+)\.\s$/,
		replace({ match: e, editor: t }) {
			if (a(t.prosemirrorState).blockNoteType === "heading") return;
			let n = parseInt(e[1]);
			return {
				type: "numberedListItem",
				props: { start: n === 1 ? void 0 : n }
			};
		}
	}],
	keyboardShortcuts: {
		Enter: ({ editor: e }) => Y(e, "numberedListItem"),
		"Mod-Shift-7": ({ editor: e }) => {
			let t = e.getTextCursorPosition();
			return e.schema.blockSchema[t.block.type].content === "inline" ? (e.updateBlock(t.block, {
				type: "numberedListItem",
				props: {}
			}), !0) : !1;
		}
	},
	prosemirrorPlugins: [Bn()]
})]), Un = j(() => ({
	type: "toggleListItem",
	propSchema: { ...H },
	content: "inline"
})), Wn = M(Un, {
	meta: { isolating: !1 },
	parse(e) {
		if (e.tagName === "DETAILS") return U(e);
		if (e.tagName === "LI") {
			let t = e.parentElement;
			if (t && (t.tagName === "UL" || t.tagName === "DIV" && t.parentElement?.tagName === "UL") && e.querySelector(":scope > details")) return U(e);
		}
	},
	parseContent: ({ el: e, schema: t }) => {
		let n = e.tagName === "DETAILS" ? e : e.querySelector(":scope > details");
		if (!n) throw Error("No details found in toggleListItem parseContent");
		return gn(n, t, "toggleListItem");
	},
	runsBefore: ["bulletListItem"],
	render(e, t) {
		let n = document.createElement("p");
		return {
			...vn(e, t, n),
			contentDOM: n
		};
	},
	toExternalHTML(e) {
		let t = document.createElement("li"), n = document.createElement("details");
		n.setAttribute("open", "");
		let r = document.createElement("summary"), i = document.createElement("p");
		return r.appendChild(i), n.appendChild(r), W(e.props, t), t.appendChild(n), {
			dom: t,
			contentDOM: i,
			childrenDOM: n
		};
	}
}, [p({
	key: "toggle-list-item-shortcuts",
	keyboardShortcuts: {
		Enter: ({ editor: e }) => Y(e, "toggleListItem"),
		"Mod-Shift-6": ({ editor: e }) => {
			let t = e.getTextCursorPosition();
			return e.schema.blockSchema[t.block.type].content === "inline" ? (e.updateBlock(t.block, {
				type: "toggleListItem",
				props: {}
			}), !0) : !1;
		}
	}
})]), Gn = j(() => ({
	type: "pageBreak",
	propSchema: {},
	content: "none"
})), Kn = M(Gn, {
	parse(e) {
		if (e.tagName === "DIV" && e.hasAttribute("data-page-break")) return {};
	},
	render() {
		let e = document.createElement("div");
		return e.setAttribute("data-page-break", ""), { dom: e };
	},
	toExternalHTML() {
		let e = document.createElement("div");
		return e.setAttribute("data-page-break", ""), { dom: e };
	}
}), qn = (e) => e.extend({ blockSpecs: { pageBreak: Kn() } }), Jn = j(() => ({
	type: "paragraph",
	propSchema: H,
	content: "inline"
})), Yn = M(Jn, {
	meta: { isolating: !1 },
	parse: (e) => {
		if (e.tagName === "P" && e.textContent?.trim()) return U(e);
	},
	render: () => {
		let e = document.createElement("p");
		return {
			dom: e,
			contentDOM: e
		};
	},
	toExternalHTML: (e) => {
		let t = document.createElement("p");
		return W(e.props, t), {
			dom: t,
			contentDOM: t
		};
	},
	runsBefore: ["default", "heading"]
}, [p({
	key: "paragraph-shortcuts",
	keyboardShortcuts: { "Mod-Alt-0": ({ editor: e }) => {
		let t = e.getTextCursorPosition();
		return e.schema.blockSchema[t.block.type].content === "inline" ? (e.updateBlock(t.block, {
			type: "paragraph",
			props: {}
		}), !0) : !1;
	} }
})]), Xn = j(() => ({
	type: "quote",
	propSchema: {
		backgroundColor: H.backgroundColor,
		textColor: H.textColor
	},
	content: "inline"
})), Zn = M(Xn, {
	meta: { isolating: !1 },
	parse(e) {
		if (e.tagName === "BLOCKQUOTE") {
			let { backgroundColor: t, textColor: n } = U(e);
			return {
				backgroundColor: t,
				textColor: n
			};
		}
	},
	render() {
		let e = document.createElement("blockquote");
		return {
			dom: e,
			contentDOM: e
		};
	},
	toExternalHTML(e) {
		let t = document.createElement("blockquote");
		return W(e.props, t), {
			dom: t,
			contentDOM: t
		};
	}
}, [p({
	key: "quote-block-shortcuts",
	keyboardShortcuts: { "Mod-Alt-q": ({ editor: e }) => {
		let t = e.getTextCursorPosition();
		return e.schema.blockSchema[t.block.type].content === "inline" ? (e.updateBlock(t.block, {
			type: "quote",
			props: {}
		}), !0) : !1;
	} },
	inputRules: [{
		find: RegExp("^>\\s$"),
		replace() {
			return {
				type: "quote",
				props: {}
			};
		}
	}, {
		find: RegExp("^\\p{Quotation_Mark}\\s$", "u"),
		replace() {
			return {
				type: "quote",
				props: {}
			};
		}
	}]
})]), Qn = 120, $n = 31, er = v.create({
	name: "BlockNoteTableExtension",
	addProseMirrorPlugins: () => [he({
		cellMinWidth: 35,
		defaultCellMinWidth: 120,
		View: null
	}), xe()],
	addKeyboardShortcuts() {
		return {
			Enter: () => this.editor.state.selection.$head.parent.type.name === "tableParagraph" ? this.editor.commands.command(({ state: e, dispatch: t }) => {
				if (!_e(e)) return !1;
				let n = ye(be(e), "vert", 1);
				return n ? (t && t(e.tr.setSelection(b.between(n, ve(n))).scrollIntoView()), !0) : !1;
			}) : !1,
			Backspace: () => {
				let e = this.editor.state.selection, t = e.empty, n = e.$head.parentOffset === 0, r = e.$head.node().type.name === "tableParagraph";
				return t && n && r;
			},
			Tab: () => this.editor.commands.command(({ state: e, dispatch: t, view: n }) => ge(1)(e, t, n)),
			"Shift-Tab": () => this.editor.commands.command(({ state: e, dispatch: t, view: n }) => ge(-1)(e, t, n))
		};
	},
	extendNodeSchema(e) {
		return { tableRole: ne(ie(e, "tableRole", {
			name: e.name,
			options: e.options,
			storage: e.storage
		})) };
	}
}), tr = { textColor: H.textColor }, nr = y.create({
	name: "tableHeader",
	addOptions() {
		return { HTMLAttributes: {} };
	},
	content: "tableContent+",
	marks: "y-attributed-delete y-attributed-insert y-attributed-format",
	addAttributes() {
		return {
			colspan: { default: 1 },
			rowspan: { default: 1 },
			colwidth: {
				default: null,
				parseHTML: (e) => {
					let t = e.getAttribute("colwidth");
					return t ? t.split(",").map((e) => parseInt(e, 10)) : null;
				}
			}
		};
	},
	tableRole: "header_cell",
	isolating: !0,
	parseHTML() {
		return [{
			tag: "th",
			getContent: (e, t) => sr(e, t)
		}];
	},
	renderHTML({ HTMLAttributes: e }) {
		return [
			"th",
			oe(this.options.HTMLAttributes, e),
			0
		];
	}
}), rr = y.create({
	name: "tableCell",
	addOptions() {
		return { HTMLAttributes: {} };
	},
	content: "tableContent+",
	marks: "y-attributed-delete y-attributed-insert y-attributed-format",
	addAttributes() {
		return {
			colspan: { default: 1 },
			rowspan: { default: 1 },
			colwidth: {
				default: null,
				parseHTML: (e) => {
					let t = e.getAttribute("colwidth");
					return t ? t.split(",").map((e) => parseInt(e, 10)) : null;
				}
			}
		};
	},
	tableRole: "cell",
	isolating: !0,
	parseHTML() {
		return [{
			tag: "td",
			getContent: (e, t) => sr(e, t)
		}];
	},
	renderHTML({ HTMLAttributes: e }) {
		return [
			"td",
			oe(this.options.HTMLAttributes, e),
			0
		];
	}
}), ir = y.create({
	name: "table",
	content: "tableRow+",
	group: "blockContent",
	tableRole: "table",
	marks: "y-attributed-delete y-attributed-insert y-attributed-format",
	isolating: !0,
	parseHTML() {
		return [{ tag: "table" }];
	},
	renderHTML({ node: e, HTMLAttributes: t }) {
		let n = Le(this.name, "table", {
			...this.options.domAttributes?.blockContent || {},
			...t
		}, this.options.domAttributes?.inlineContent || {}), r = document.createElement("colgroup");
		for (let t of e.children[0].children) if (t.attrs.colwidth) for (let e of t.attrs.colwidth) {
			let t = document.createElement("col");
			e && (t.style = `width: ${e}px`), r.appendChild(t);
		}
		else r.appendChild(document.createElement("col"));
		return n.dom.firstChild?.appendChild(r), n;
	},
	addNodeView() {
		return ({ node: e, HTMLAttributes: t }) => {
			class n extends me {
				constructor(e, t, n) {
					super(e, t), this.node = e, this.cellMinWidth = t, this.blockContentHTMLAttributes = n;
					let r = document.createElement("div");
					r.className = D("bn-block-content", n.class), r.setAttribute("data-content-type", "table");
					for (let [e, t] of Object.entries(n)) e !== "class" && r.setAttribute(e, t);
					let i = this.dom, a = document.createElement("div");
					a.className = "tableWrapper-inner", a.appendChild(i.firstChild), i.appendChild(a), r.appendChild(i);
					let o = document.createElement("div");
					o.className = "table-widgets-container", o.style.position = "relative", i.appendChild(o), this.dom = r;
				}
				ignoreMutation(e) {
					return !e.target.closest(".tableWrapper-inner") || super.ignoreMutation(e);
				}
				update(e) {
					if (!super.update(e)) return !1;
					for (let [t, n] of Object.entries(tr)) {
						let r = k(t), i = e.attrs[t];
						i === n.default ? this.dom.removeAttribute(r) : this.dom.setAttribute(r, String(i));
					}
					return !0;
				}
			}
			return new n(e, 120, {
				...this.options.domAttributes?.blockContent || {},
				...t
			});
		};
	}
}), ar = y.create({
	name: "tableParagraph",
	group: "tableContent",
	content: "inline*",
	parseHTML() {
		return [{
			tag: "p",
			getAttrs: (e) => {
				if (typeof e == "string" || !e.textContent || !e.closest("[data-content-type]")) return !1;
				let t = e.parentElement;
				return t === null ? !1 : t.tagName === "TD" || t.tagName === "TH" ? {} : !1;
			},
			node: "tableParagraph"
		}];
	},
	renderHTML({ HTMLAttributes: e }) {
		return [
			"p",
			e,
			0
		];
	}
}), or = y.create({
	name: "tableRow",
	addOptions() {
		return { HTMLAttributes: {} };
	},
	content: "(tableCell | tableHeader)+",
	tableRole: "row",
	marks: "y-attributed-delete y-attributed-insert y-attributed-format",
	parseHTML() {
		return [{ tag: "tr" }];
	},
	renderHTML({ HTMLAttributes: e }) {
		return [
			"tr",
			oe(this.options.HTMLAttributes, e),
			0
		];
	}
});
function sr(e, t) {
	let n = m.fromSchema(t).parse(e, { topNode: t.nodes.blockGroup.create() }), r = [];
	return n.content.descendants((e) => {
		if (e.isInline) return r.push(e), !1;
	}), h.fromArray(r);
}
var cr = () => Ye({
	node: ir,
	type: "table",
	content: "table"
}, tr, [p({
	key: "table-extensions",
	tiptapExtensions: [
		er,
		ar,
		nr,
		rr,
		or
	]
}), p({
	key: "table-keyboard-delete",
	keyboardShortcuts: { Backspace: ({ editor: e }) => {
		if (!(e.prosemirrorState.selection instanceof fe)) return !1;
		let t = e.getTextCursorPosition().block, n = t.content, r = 0;
		for (let e of n.rows) for (let t of e.cells) {
			if ("type" in t && t.content.length > 0 || !("type" in t) && t.length > 0) return !1;
			r++;
		}
		let i = 0;
		return e.prosemirrorState.selection.forEachCell(() => {
			i++;
		}), i < r ? !1 : (e.transact(() => {
			(e.getPrevBlock(t) || e.getNextBlock(t)) && e.setTextCursorPosition(t), e.removeBlocks([t]);
		}), !0);
	} }
})]), lr = (e) => ({
	url: e.src || void 0,
	previewWidth: e.width || void 0,
	name: e.getAttribute("data-name") || void 0
}), ur = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" fill=\"currentColor\"><path d=\"M2 3.9934C2 3.44476 2.45531 3 2.9918 3H21.0082C21.556 3 22 3.44495 22 3.9934V20.0066C22 20.5552 21.5447 21 21.0082 21H2.9918C2.44405 21 2 20.5551 2 20.0066V3.9934ZM8 5V19H16V5H8ZM4 5V7H6V5H4ZM18 5V7H20V5H18ZM4 9V11H6V9H4ZM18 9V11H20V9H18ZM4 13V15H6V13H4ZM18 13V15H20V13H18ZM4 17V19H6V17H4ZM18 17V19H20V17H18Z\"></path></svg>", dr = j((e) => ({
	type: "video",
	propSchema: {
		textAlignment: H.textAlignment,
		backgroundColor: H.backgroundColor,
		name: { default: "" },
		url: { default: "" },
		caption: { default: "" },
		showPreview: { default: !0 },
		previewWidth: {
			default: void 0,
			type: "number"
		}
	},
	content: "none"
})), fr = (e) => (e) => {
	if (e.tagName === "VIDEO") {
		if (e.closest("figure")) return;
		let { backgroundColor: t } = U(e);
		return {
			...lr(e),
			backgroundColor: t
		};
	}
	if (e.tagName === "FIGURE") {
		let t = G(e, "video");
		if (!t) return;
		let { targetElement: n, caption: r } = t, { backgroundColor: i } = U(e);
		return {
			...lr(n),
			backgroundColor: i,
			caption: r
		};
	}
}, pr = M(dr, (e) => ({
	meta: { fileBlockAccept: ["video/*"] },
	parse: fr(e),
	render(t, n) {
		let r = document.createElement("div");
		r.innerHTML = e.icon ?? "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" fill=\"currentColor\"><path d=\"M2 3.9934C2 3.44476 2.45531 3 2.9918 3H21.0082C21.556 3 22 3.44495 22 3.9934V20.0066C22 20.5552 21.5447 21 21.0082 21H2.9918C2.44405 21 2 20.5551 2 20.0066V3.9934ZM8 5V19H16V5H8ZM4 5V7H6V5H4ZM18 5V7H20V5H18ZM4 9V11H6V9H4ZM18 9V11H20V9H18ZM4 13V15H6V13H4ZM18 13V15H20V13H18ZM4 17V19H6V17H4ZM18 17V19H20V17H18Z\"></path></svg>";
		let i = document.createElement("div");
		i.className = "bn-visual-media-wrapper";
		let a = document.createElement("video");
		return a.className = "bn-visual-media", n.resolveFileUrl ? n.resolveFileUrl(t.props.url).then((e) => {
			a.src = e;
		}) : a.src = t.props.url, a.controls = !0, a.contentEditable = "false", a.draggable = !1, t.props.previewWidth && (a.width = t.props.previewWidth), i.appendChild(a), Cn(t, n, { dom: i }, i, r.firstElementChild);
	},
	toExternalHTML(e) {
		if (!e.props.url) return { dom: document.createElement("video") };
		let t;
		return e.props.showPreview ? (t = document.createElement("video"), t.src = e.props.url, e.props.previewWidth && (t.width = e.props.previewWidth)) : (t = document.createElement("a"), t.href = e.props.url, t.textContent = e.props.name || e.props.url), e.props.caption ? e.props.showPreview ? Yt(t, e.props.caption) : J(t, e.props.caption) : { dom: t };
	},
	runsBefore: ["file"]
})), mr = async (e) => {
	let t = new FormData();
	return t.append("file", e), (await (await fetch("https://tmpfiles.org/api/v1/upload", {
		method: "POST",
		body: t
	})).json()).data.url.replace("tmpfiles.org/", "tmpfiles.org/dl/");
};
//#endregion
//#region src/blocks/defaultBlockTypeGuards.ts
function X(e, t, n) {
	if (!(t in e.schema.blockSpecs)) return !1;
	if (!n) return !0;
	for (let [r, i] of Object.entries(n)) {
		if (!(r in e.schema.blockSpecs[t].config.propSchema)) return !1;
		if (typeof i == "string") {
			if (e.schema.blockSpecs[t].config.propSchema[r].default !== void 0 && typeof e.schema.blockSpecs[t].config.propSchema[r].default !== i || e.schema.blockSpecs[t].config.propSchema[r].type !== void 0 && e.schema.blockSpecs[t].config.propSchema[r].type !== i) return !1;
		} else {
			if (e.schema.blockSpecs[t].config.propSchema[r].default !== i.default || e.schema.blockSpecs[t].config.propSchema[r].default === void 0 && i.default === void 0 && e.schema.blockSpecs[t].config.propSchema[r].type !== i.type || typeof e.schema.blockSpecs[t].config.propSchema[r].values != typeof i.values) return !1;
			if (typeof e.schema.blockSpecs[t].config.propSchema[r].values == "object" && typeof i.values == "object") {
				for (let n of i.values) if (!e.schema.blockSpecs[t].config.propSchema[r].values.includes(n)) return !1;
			}
		}
	}
	return !0;
}
function hr(e, t, n, r) {
	return X(t, n, r) && e.type === n;
}
function gr(e) {
	return e instanceof fe;
}
//#endregion
//#region src/extensions/FormattingToolbar/FormattingToolbar.ts
var Z = p(({ editor: e }) => {
	let t = f(!1), n = () => e.transact((e) => {
		if (e.selection.empty || e.selection instanceof b && e.doc.textBetween(e.selection.from, e.selection.to).length === 0) return !1;
		let t = !1;
		return e.selection.content().content.descendants((e) => (e.type.spec.code && (t = !0), !t)), !t;
	});
	return {
		key: "formattingToolbar",
		store: t,
		mount({ dom: r, signal: i }) {
			let a = !1, o = !1, s = e.onChange(() => {
				a || o || t.setState(n());
			}), c = e.onSelectionChange(() => {
				a || o || t.setState(n());
			});
			r.addEventListener("pointerdown", () => {
				a = !0, t.setState(!1);
			}, { signal: i }), e.prosemirrorView.root.addEventListener("pointerup", () => {
				a = !1, e.isFocused() && t.setState(n());
			}, {
				signal: i,
				capture: !0
			}), r.addEventListener("pointercancel", () => {
				a = !0;
			}, {
				signal: i,
				capture: !0
			}), e.prosemirrorView.root.addEventListener("dragstart", () => {
				o = !0, t.setState(!1);
			}, { signal: i }), e.prosemirrorView.root.addEventListener("dragend", () => {
				o = !1;
			}, { signal: i }), i.addEventListener("abort", () => {
				s(), c();
			});
		}
	};
});
//#endregion
//#region src/api/positionMapping.ts
function _r(e, t, n = "left") {
	let r = e.getExtension("yPositionMapping");
	if (r) return r.mapPosition(t, n);
	let i = e.getExtension("positionMapping");
	if (i) return i.mapPosition(t, n);
	throw Error("No position mapping extension found");
}
//#endregion
//#region src/extensions/SuggestionMenu/SuggestionMenu.ts
var vr = re((e) => e.type.name === "blockContainer"), yr = class {
	state;
	emitUpdate;
	rootEl;
	pluginState;
	constructor(e, t, n) {
		this.editor = e, this.pluginState = void 0, this.emitUpdate = (e) => {
			if (!this.state) throw Error("Attempting to update uninitialized suggestions menu");
			t(e, {
				...this.state,
				ignoreQueryLength: this.pluginState?.ignoreQueryLength
			});
		}, this.rootEl = n.root, this.rootEl?.addEventListener("scroll", this.handleScroll, !0);
	}
	handleScroll = () => {
		if (this.state?.show) {
			let e = this.rootEl?.querySelector(`[data-decoration-id="${this.pluginState.decorationId}"]`);
			if (!e) return;
			this.state.referencePos = e.getBoundingClientRect().toJSON(), this.emitUpdate(this.pluginState.triggerCharacter);
		}
	};
	update(e, t) {
		let n = Q.getState(t), r = Q.getState(e.state), i = n === void 0 && r !== void 0, a = n !== void 0 && r === void 0;
		if (!i && !(n !== void 0 && r !== void 0) && !a) return;
		if (this.pluginState = a ? n : r, a || !this.editor.isEditable) {
			this.state && (this.state.show = !1), this.emitUpdate(this.pluginState.triggerCharacter);
			return;
		}
		let o = this.rootEl?.querySelector(`[data-decoration-id="${this.pluginState.decorationId}"]`);
		this.editor.isEditable && o && (this.state = {
			show: !0,
			referencePos: o.getBoundingClientRect().toJSON(),
			query: this.pluginState.query
		}, this.emitUpdate(this.pluginState.triggerCharacter));
	}
	destroy() {
		this.rootEl?.removeEventListener("scroll", this.handleScroll, !0);
	}
	closeMenu = () => {
		this.editor.transact((e) => e.setMeta(Q, null));
	};
	clearQuery = () => {
		this.pluginState !== void 0 && this.editor._tiptapEditor.chain().focus().deleteRange({
			from: this.pluginState.queryStartPos() - (this.pluginState.deleteTriggerCharacter ? this.pluginState.triggerCharacter.length : 0),
			to: this.editor.transact((e) => e.selection.from)
		}).run();
	};
}, Q = new ce("SuggestionMenuPlugin"), br = p(({ editor: e }) => {
	let t = /* @__PURE__ */ new Map(), n, r = f(void 0);
	return {
		key: "suggestionMenu",
		store: r,
		addSuggestionMenu: (e) => {
			t.set(e.triggerCharacter, e);
		},
		removeSuggestionMenu: (e) => {
			t.delete(e);
		},
		closeMenu: () => {
			n?.closeMenu();
		},
		clearQuery: () => {
			n?.clearQuery();
		},
		shown: () => n?.state?.show || !1,
		openSuggestionMenu: (t, n) => {
			e.headless || (e.focus(), e.transact((e) => {
				n?.deleteTriggerCharacter && e.insertText(t), e.scrollIntoView().setMeta(Q, {
					triggerCharacter: t,
					deleteTriggerCharacter: n?.deleteTriggerCharacter || !1,
					ignoreQueryLength: n?.ignoreQueryLength || !1
				});
			}));
		},
		prosemirrorPlugins: [new se({
			key: Q,
			view: (t) => (n = new yr(e, (e, t) => {
				r.setState({
					...t,
					triggerCharacter: e
				});
			}, t), n),
			state: {
				init() {},
				apply: (t, r, i, a) => {
					if (t.selection.$from.parent.type.spec.code) return r;
					let o = t.getMeta(Q);
					if (typeof o == "object" && o) {
						r && n?.closeMenu();
						let t = _r(e, a.selection.from - o.triggerCharacter.length);
						return {
							triggerCharacter: o.triggerCharacter,
							deleteTriggerCharacter: o.deleteTriggerCharacter !== !1,
							queryStartPos: () => t() + o.triggerCharacter.length,
							query: "",
							decorationId: `id_${Math.floor(Math.random() * 4294967295)}`,
							ignoreQueryLength: o?.ignoreQueryLength
						};
					}
					if (r === void 0) return r;
					if (a.selection.from !== a.selection.to || o === null || t.getMeta("focus") || t.getMeta("blur") || t.getMeta("pointer") || r.triggerCharacter !== void 0 && a.selection.from < r.queryStartPos() || !a.selection.$from.sameParent(a.doc.resolve(r.queryStartPos()))) return;
					let s = { ...r };
					return s.query = a.doc.textBetween(r.queryStartPos(), a.selection.from), s;
				}
			},
			props: {
				handleTextInput(e, n, r, i) {
					if (n === r) {
						let r = e.state.doc;
						for (let [a, o] of t) {
							let t = a.length > 1 ? r.textBetween(n - a.length, n) + i : i;
							if (a === t) {
								if (o.shouldOpen && !o.shouldOpen(e.state.tr)) continue;
								return e.dispatch(e.state.tr.insertText(i)), e.dispatch(e.state.tr.setMeta(Q, { triggerCharacter: t }).scrollIntoView()), !0;
							}
						}
					}
					return !1;
				},
				decorations(e) {
					let t = this.getState(e);
					if (t === void 0) return null;
					if (!t.deleteTriggerCharacter) {
						let n = vr(e.selection);
						if (n) return ke.create(e.doc, [Oe.node(n.pos, n.pos + n.node.nodeSize, {
							nodeName: "span",
							class: "bn-suggestion-decorator",
							"data-decoration-id": t.decorationId
						})]);
					}
					return ke.create(e.doc, [Oe.inline(t.queryStartPos() - t.triggerCharacter.length, t.queryStartPos(), {
						nodeName: "span",
						class: "bn-suggestion-decorator",
						"data-decoration-id": t.decorationId
					})]);
				}
			}
		})]
	};
});
//#endregion
//#region src/extensions/SuggestionMenu/getDefaultSlashMenuItems.ts
function xr(e) {
	let t = e.getTextCursorPosition().block, n = e.schema.blockSchema[t.type].content;
	for (; n === "none";) {
		if (t = e.getTextCursorPosition().nextBlock, t === void 0) return;
		n = e.schema.blockSchema[t.type].content, e.setTextCursorPosition(t, "end");
	}
}
function $(t, n) {
	let r = t.getTextCursorPosition().block;
	if (r.content === void 0) throw Error("Slash Menu open in a block that doesn't contain content.");
	let i;
	return Array.isArray(r.content) && (r.content.length === 1 && e(r.content[0]) && r.content[0].type === "text" && r.content[0].text === "/" || r.content.length === 0) ? (i = t.updateBlock(r, n), t.setTextCursorPosition(i)) : (i = t.insertBlocks([n], r, "after")[0], t.setTextCursorPosition(t.getTextCursorPosition().nextBlock)), xr(t), i;
}
function Sr(e) {
	let t = [];
	return X(e, "heading", { level: "number" }) && (e.schema.blockSchema.heading.propSchema.level.values || []).filter((e) => e <= 3).forEach((n) => {
		t.push({
			onItemClick: () => {
				$(e, {
					type: "heading",
					props: { level: n }
				});
			},
			badge: E(`Mod-Alt-${n}`),
			key: n === 1 ? "heading" : `heading_${n}`,
			...e.dictionary.slash_menu[n === 1 ? "heading" : `heading_${n}`]
		});
	}), X(e, "quote") && t.push({
		onItemClick: () => {
			$(e, { type: "quote" });
		},
		key: "quote",
		...e.dictionary.slash_menu.quote
	}), X(e, "toggleListItem") && t.push({
		onItemClick: () => {
			$(e, { type: "toggleListItem" });
		},
		badge: E("Mod-Shift-6"),
		key: "toggle_list",
		...e.dictionary.slash_menu.toggle_list
	}), X(e, "numberedListItem") && t.push({
		onItemClick: () => {
			$(e, { type: "numberedListItem" });
		},
		badge: E("Mod-Shift-7"),
		key: "numbered_list",
		...e.dictionary.slash_menu.numbered_list
	}), X(e, "bulletListItem") && t.push({
		onItemClick: () => {
			$(e, { type: "bulletListItem" });
		},
		badge: E("Mod-Shift-8"),
		key: "bullet_list",
		...e.dictionary.slash_menu.bullet_list
	}), X(e, "checkListItem") && t.push({
		onItemClick: () => {
			$(e, { type: "checkListItem" });
		},
		badge: E("Mod-Shift-9"),
		key: "check_list",
		...e.dictionary.slash_menu.check_list
	}), X(e, "paragraph") && t.push({
		onItemClick: () => {
			$(e, { type: "paragraph" });
		},
		badge: E("Mod-Alt-0"),
		key: "paragraph",
		...e.dictionary.slash_menu.paragraph
	}), X(e, "codeBlock") && t.push({
		onItemClick: () => {
			$(e, { type: "codeBlock" });
		},
		badge: E("Mod-Alt-c"),
		key: "code_block",
		...e.dictionary.slash_menu.code_block
	}), X(e, "divider") && t.push({
		onItemClick: () => {
			$(e, { type: "divider" });
		},
		key: "divider",
		...e.dictionary.slash_menu.divider
	}), X(e, "table") && t.push({
		onItemClick: () => {
			$(e, {
				type: "table",
				content: {
					type: "tableContent",
					rows: [{ cells: [
						"",
						"",
						""
					] }, { cells: [
						"",
						"",
						""
					] }]
				}
			});
		},
		badge: void 0,
		key: "table",
		...e.dictionary.slash_menu.table
	}), X(e, "image", { url: "string" }) && t.push({
		onItemClick: () => {
			let t = $(e, { type: "image" });
			e.getExtension(K)?.showMenu(t.id), e.getExtension(Z)?.store.setState(!1);
		},
		key: "image",
		...e.dictionary.slash_menu.image
	}), X(e, "video", { url: "string" }) && t.push({
		onItemClick: () => {
			let t = $(e, { type: "video" });
			e.getExtension(K)?.showMenu(t.id), e.getExtension(Z)?.store.setState(!1);
		},
		key: "video",
		...e.dictionary.slash_menu.video
	}), X(e, "audio", { url: "string" }) && t.push({
		onItemClick: () => {
			let t = $(e, { type: "audio" });
			e.getExtension(K)?.showMenu(t.id), e.getExtension(Z)?.store.setState(!1);
		},
		key: "audio",
		...e.dictionary.slash_menu.audio
	}), X(e, "file", { url: "string" }) && t.push({
		onItemClick: () => {
			let t = $(e, { type: "file" });
			e.getExtension(K)?.showMenu(t.id), e.getExtension(Z)?.store.setState(!1);
		},
		key: "file",
		...e.dictionary.slash_menu.file
	}), X(e, "heading", {
		level: "number",
		isToggleable: "boolean"
	}) && (e.schema.blockSchema.heading.propSchema.level.values || []).filter((e) => e <= 3).forEach((n) => {
		t.push({
			onItemClick: () => {
				$(e, {
					type: "heading",
					props: {
						level: n,
						isToggleable: !0
					}
				});
			},
			key: n === 1 ? "toggle_heading" : `toggle_heading_${n}`,
			...e.dictionary.slash_menu[n === 1 ? "toggle_heading" : `toggle_heading_${n}`]
		});
	}), X(e, "heading", { level: "number" }) && (e.schema.blockSchema.heading.propSchema.level.values || []).filter((e) => e > 3).forEach((n) => {
		t.push({
			onItemClick: () => {
				$(e, {
					type: "heading",
					props: { level: n }
				});
			},
			badge: E(`Mod-Alt-${n}`),
			key: `heading_${n}`,
			...e.dictionary.slash_menu[`heading_${n}`]
		});
	}), t.push({
		onItemClick: () => {
			e.getExtension(br)?.openSuggestionMenu(":", {
				deleteTriggerCharacter: !0,
				ignoreQueryLength: !0
			});
		},
		key: "emoji",
		...e.dictionary.slash_menu.emoji
	}), t;
}
function Cr(e, t) {
	return e.filter(({ title: e, aliases: n }) => e.toLowerCase().includes(t.toLowerCase()) || n && n.filter((e) => e.toLowerCase().includes(t.toLowerCase())).length !== 0);
}
//#endregion
//#region src/blocks/PageBreak/getPageBreakSlashMenuItems.ts
function wr(e) {
	return "pageBreak" in e.schema.blockSchema;
}
function Tr(e) {
	let t = [];
	return wr(e) && t.push({
		...e.dictionary.slash_menu.page_break,
		onItemClick: () => {
			$(e, { type: "pageBreak" });
		},
		key: "page_break"
	}), t;
}
//#endregion
//#region src/blocks/defaultBlocks.ts
var Er = {
	audio: nn(),
	bulletListItem: Fn(),
	checkListItem: Ln(),
	codeBlock: cn(),
	divider: dn(),
	file: hn(),
	heading: Sn(),
	image: An(),
	numberedListItem: Hn(),
	paragraph: Yn(),
	quote: Zn(),
	table: cr(),
	toggleListItem: Wn(),
	video: pr()
}, Dr = ct({
	type: "textColor",
	propSchema: "string"
}, {
	render: () => {
		let e = document.createElement("span");
		return {
			dom: e,
			contentDOM: e
		};
	},
	toExternalHTML: (e) => {
		let t = document.createElement("span");
		return e !== H.textColor.default && (t.style.color = e in V ? V[e].text : e), {
			dom: t,
			contentDOM: t
		};
	},
	parse: (e) => {
		if (e.tagName === "SPAN" && e.style.color) return e.style.color;
	}
}), Or = ct({
	type: "backgroundColor",
	propSchema: "string"
}, {
	render: () => {
		let e = document.createElement("span");
		return {
			dom: e,
			contentDOM: e
		};
	},
	toExternalHTML: (e) => {
		let t = document.createElement("span");
		return e !== H.backgroundColor.default && (t.style.backgroundColor = e in V ? V[e].background : e), {
			dom: t,
			contentDOM: t
		};
	},
	parse: (e) => {
		if (e.tagName === "SPAN" && e.style.backgroundColor) return e.style.backgroundColor;
	}
}), kr = {
	bold: P(Ae, "boolean"),
	italic: P(Me, "boolean"),
	underline: P(Pe, "boolean"),
	strike: P(Ne, "boolean"),
	code: P(je.extend({ addInputRules() {
		return [ae({
			find: /(^|[^`])`([^`]+)`(?!`)$/,
			type: this.type
		}), new ee({
			find: /(^|[^`])`([^`]+)`(?!`) $/,
			handler: ({ state: e, range: t, match: n }) => {
				let { tr: r, schema: i } = e, a = n[1], o = n[2];
				r.replaceWith(t.from + a.length, t.to, [i.text(o, [this.type.create()]), i.text(" ")]);
			}
		})];
	} }), "boolean"),
	textColor: Dr,
	backgroundColor: Or
}, Ar = ot(kr), jr = {
	text: {
		config: "text",
		implementation: {}
	},
	link: {
		config: "link",
		implementation: {}
	}
}, Mr = rt(jr), Nr = class e extends vt {
	static create(t) {
		return new e({
			blockSpecs: t?.blockSpecs ?? Er,
			inlineContentSpecs: t?.inlineContentSpecs ?? jr,
			styleSpecs: t?.styleSpecs ?? kr
		});
	}
};
//#endregion
export { pn as $, rt as $t, Yn as A, Dt as At, Pn as B, vt as Bt, cr as C, Ie as Cn, Bt as Ct, Xn as D, S as Dn, z as Dt, Qn as E, T as En, B as Et, Wn as F, St as Ft, An as G, at as Gt, jn as H, ct as Ht, Vn as I, xt as It, kn as J, it as Jt, Dn as K, P as Kt, Hn as L, yt as Lt, Kn as M, kt as Mt, qn as N, Ot as Nt, Zn as O, C as On, R as Ot, Un as P, Et as Pt, _n as Q, tt as Qt, Ln as R, Ct as Rt, fr as S, Fe as Sn, V as St, $n as T, w as Tn, It as Tt, Tn as U, st as Ut, Fn as V, gt as Vt, En as W, N as Wt, Sn as X, et as Xt, xn as Y, $e as Yt, vn as Z, nt as Zt, gr as _, Be as _n, Ut as _t, Ar as a, Ye as an, cn as at, dr as b, ze as bn, U as bt, Tr as c, A as cn, $t as ct, $ as d, Ke as dn, Qt as dt, Qe as en, hn as et, br as f, Ve as fn, nn as ft, X as g, O as gn, H as gt, hr as h, He as hn, W as ht, jr as i, Ze as in, sn as it, Gn as j, At as jt, Jn as k, x as kn, Pt as kt, Cr as l, k as ln, en as lt, Z as m, We as mn, K as mt, Er as n, j as nn, un as nt, kr as o, Je as on, ln as ot, _r as p, Ue as pn, Xt as pt, On as q, ot as qt, Mr as r, M as rn, dn as rt, wr as s, qe as sn, Zt as st, Nr as t, Xe as tn, mn as tt, Sr as u, Ge as un, tn as ut, mr as v, Le as vn, Gt as vt, tr as w, D as wn, zt as wt, pr as x, E as xn, Ht as xt, ur as y, Re as yn, Wt as yt, In as z, wt as zt };

//# sourceMappingURL=blocks-CCGgWk8H.js.map